import React from 'react';
import { Link } from 'react-router-dom';
import _, { isEqual, groupBy, forEach } from 'lodash';
import classNames from 'classnames';
import routes from '../routes';
import moment from 'moment';
import { checkPermission } from '../utils/route-auth';
import { MODULE_PERMISSIONS, PERMISSION } from '../constants/permission';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import { apiBaseUrl, authBaseUrl, endPoints, platformConfigUrl, timestampBaseUrl } from '../constants/configuration';
import { Blowfish } from 'javascript-blowfish';
import momentTimeZone from 'moment-timezone';
import { useRef,useEffect,useCallback} from 'react';


export const halfEvenRound = (value, precision = 0) => {
  const numberValue = Number(value);

  if (!isFinite(numberValue)) {
    return value;
  }

  const factor = Math.pow(10, precision);
  const scaledValue = numberValue * factor;
  const sign = scaledValue < 0 ? -1 : 1;
  const absoluteValue = Math.abs(scaledValue);
  const floorValue = Math.floor(absoluteValue);
  const decimalValue = absoluteValue - floorValue;
  const epsilon = 1e-8;

  if (Math.abs(decimalValue - 0.5) <= epsilon) {
    const roundedValue = floorValue % 2 === 0 ? floorValue : floorValue + 1;
    return sign * roundedValue / factor;
  }

  return sign * Math.round(absoluteValue) / factor;
};


export const renderTabButton = ({ pathname, tenantId }) => {
  let button = '';
  const currentPath = pathname.substr(pathname.lastIndexOf('/') + 1);
  switch (currentPath) {
    case routes.ion.adUnit.name:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.ADUNIT.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.adUnit.name}/${routes.ion.adUnit.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Ad Unit
        </Link>
      ) : (
        ''
      );
      break;
    case routes.ion.adUnitGroup.name:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.ADUNITGROUPS.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.adUnitGroup.name}/${routes.ion.adUnitGroup.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Ad Unit Group
        </Link>
      ) : (
        ''
      );
      break;
    case routes.ion.privateMarketPlace.name:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.PRIVATEMARKETPLACE.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.privateMarketPlace.name}/${routes.ion.privateMarketPlace.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Add PMP
        </Link>
      ) : (
        ''
      );
      break;
    // case routes.campaign.pmp.name:
    //   // button = checkPermission({ permissions: [PERMISSION.EXCHANGE.PRIVATEMARKETPLACE.ADD] }) ? <Link to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.privateMarketPlace.name}/${routes.ion.privateMarketPlace.add}`} className="btn btn-primary tab-btn"><i className="mdi mdi-plus-box"></i>Add PMP</Link> : '';
    //   button = <Link to={`/${routes.mainRoute}/${routes.containers.campaign}/${routes.campaign.pmp.name}/${routes.campaign.pmp.add}`} className="btn btn-primary tab-btn"><i className="mdi mdi-plus-box"></i>Add Private Market Place</Link>
    //   break;
    case routes.ion.mediation.name:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.MEDIATION.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.mediation.name}/${routes.ion.mediation.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Mediation Add
        </Link>
      ) : (
        ''
      );
      break;
    case routes.ion.mediationAdGroup.name:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.MEDIATIONADGROUP.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.mediationAdGroup.name}/${routes.ion.mediationAdGroup.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Mediation AdGroup
        </Link>
      ) : (
        ''
      );
      break;
    case routes.creative.display.name:
      button = checkPermission({
        permissions: [PERMISSION.CREATIVE.DISPLAY.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.creative}/${routes.creative.display.name}/${routes.creative.display.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Display Group
        </Link>
      ) : (
        ''
      );
      break;
    case routes.creative.video.name:
      button = checkPermission({
        permissions: [PERMISSION.CREATIVE.VIDEO.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.creative}/${routes.creative.video.name}/${routes.creative.video.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Video Group
        </Link>
      ) : (
        ''
      );
      break;
    case routes.creative.native.name:
      button = checkPermission({
        permissions: [PERMISSION.CREATIVE.NATIVE.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.creative}/${routes.creative.native.name}/${routes.creative.native.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Native Group
        </Link>
      ) : (
        ''
      );
      break;
    case routes.creative.audio.name:
      button = (
        /* checkPermission({ permissions: [PERMISSION.CREATIVE.AUDIO.ADD] }) ? */ <Link
          to={`/${routes.mainRoute}/${routes.containers.creative}/${routes.creative.audio.name}/${routes.creative.audio.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Audio Creative
        </Link>
      ) /* : '' */;
      break;
    // case routes.containers.campaign:
    //   button = checkPermission({
    //     permissions: [PERMISSION.CAMPAIGN.CAMPAIGN.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.campaign}/${routes.campaign.campaign.name}/${routes.campaign.campaign.add}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Campaign
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;

    // case routes.containers.campaign:
    //   button = checkPermission({
    //     permissions: [PERMISSION.CAMPAIGN.CAMPAIGN.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.campaign}/${routes.campaign.campaign.name}/${routes.campaign.campaign.add}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Campaign
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;


    // case routes.dataConfig.platformVaraible.name:
    //   button =
    //     // checkPermission({
    //     //   permissions: [PERMISSION.ADMIN.TENANT.ADD]
    //     // })
    //     //  ? (
    //     <div>
    //       <Link
    //         to={`/${routes.mainRoute}/${routes.containers.dataConfig}/${routes.dataConfig.platformVaraible.name}/${routes.dataConfig.platformVaraible.addPlatformVariablesMapping}`}
    //         className="btn btn-primary tab-btn "
    //       >
    //         <i className="mdi mdi-plus"></i>Add New Variable
    //       </Link><br />
    //     </div>
    //   // ) : (
    //   //   ''
    //   // );
    //   break;


    case routes.dataConfig.dspPlatform.name:
      button =
        checkPermission({
          permissions: [PERMISSION.ADMIN.DATACONFIG.ADD]
        })
          ? (
            <div>
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.containers.dataConfig}/${routes.dataConfig.dspPlatform.name}/${routes.dataConfig.dspPlatform.addDspPlatform}`}
                className="btn btn-primary tab-btn "
              >
                <i className="mdi mdi-plus"></i>New Platform
              </Link><br />
            </div>
          ) : (
            ''
          );
      break;


    case routes.dataConfig.variables.name:
      button =
        checkPermission({
          permissions: [PERMISSION.ADMIN.DATACONFIG.ADD]
        })
          ? (
            <div>
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.containers.dataConfig}/${routes.dataConfig.variables.name}/${routes.dataConfig.variables.addVariables}`}
                className="btn btn-primary tab-btn "
              >
                <i className="mdi mdi-plus"></i>Add Variable / Value
              </Link><br />
            </div>
          ) : (
            ''
          );
      break;


    case routes.dataConfig.platformTenantAdvertiser.name:
      button =
        // checkPermission({
        //   permissions: [PERMISSION.ADMIN.TENANT.ADD]
        // })
        //  ? (
        <div>
          <Link
            to={`/${routes.mainRoute}/${routes.containers.dataConfig}/${routes.dataConfig.platformTenantAdvertiser.name}/${routes.dataConfig.platformTenantAdvertiser.addPlatformTenantAdvertiser}`}
            className="btn btn-primary tab-btn "
          >
            <i className="mdi mdi-plus"></i>Add New Tenant - Advertiser Mapping
          </Link><br />
        </div>
      // ) : (
      //   ''
      // );
      break;


























    // case routes.admin.tenant.name:
    //   button =
    //     checkPermission({
    //       permissions: [PERMISSION.ADMIN.TENANT.ADD]
    //     }) ? (
    //       <div>
    //         <Link
    //           to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}/${routes.admin.tenant.add}`}
    //           className="btn btn-primary tab-btn "
    //         >
    //           <i className="mdi mdi-plus"></i>Tenant
    //         </Link><br />
    //         {/* <Link
    //       to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}/${routes.admin.tenant.addMgr}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Mgr Tenant
    //     </Link> */}
    //       </div>
    //     ) : (
    //       ''
    //     );
    //   break;

    // case routes.admin.supplyPartner.name:
    //   button = checkPermission({
    //     permissions: [PERMISSION.ADMIN.SUPPLYPARTNER.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.supplyPartner.name}/${routes.admin.supplyPartner.add}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Supply Partner
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;

    // case routes.admin.variable.name:
    //   button = checkPermission({
    //     permissions: [PERMISSION.ADMIN.VARIABLE.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.variable.name}/${routes.admin.variable.add}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Variable
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;
    case routes.admin.account.name:
      button =
        checkPermission({
          permissions: [PERMISSION.ADMIN.PROFILE.ADD]
        }) && tenantId >= 0 && !isTenantAdvertiser(tenantId) ?
          ''
          // (
          //   <Link
          //     to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}/${routes.admin.account.add}`}
          //     className="btn btn-primary tab-btn"
          //   >
          //     <i className="mdi mdi-plus"></i>Add Advertiser
          //   </Link>
          // )
          :
          (
            ''
          );
      break;
    case routes.admin.platform.name:
      button =
        //  checkPermission({
        //   permissions: [PERMISSION.ADMIN.ACCOUNT.ADD]
        // }) ?
        (
          <Link
            to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.platform.name}/${routes.admin.platform.add}`}
            className="btn btn-primary tab-btn"
          >
            <i className="mdi mdi-plus-box"></i>Platform
          </Link>
        )
      // : (
      //   ''
      // );
      break;
    case routes.admin.currencyRate.name:
      button =
        //  checkPermission({
        //   permissions: [PERMISSION.ADMIN.ACCOUNT.ADD]
        // }) ?
        (
          <Link
            to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.currencyRate.name}/${routes.admin.currencyRate.add}`}
            className="btn btn-primary tab-btn"
          >
            <i className="mdi mdi-plus-box"></i>Currency Rate
          </Link>
        )
      // : (
      //   ''
      // );
      break;

    // case routes.admin.user.name:
    //   button = checkPermission({
    //     permissions: [PERMISSION.ADMIN.USERS.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}/${routes.admin.user.add}`}
    //       className='text-white text-decoration-none btn btn-primary mx-4'
    //       style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
    //     >
    //       <i className="ti ti-plus ti-sm"></i>
    //       User
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;
    // case routes.admin.demandPartner.name:
    //   button = checkPermission({
    //     permissions: [PERMISSION.ADMIN.DEMANDPARTNER.ADD]
    //   }) ? (
    //     <Link
    //       to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.demandPartner.name}/${routes.admin.demandPartner.add}`}
    //       className="btn btn-primary tab-btn"
    //     >
    //       <i className="mdi mdi-plus-box"></i>Demand Partner
    //     </Link>
    //   ) : (
    //     ''
    //   );
    //   break;
    case routes.audience.apr.name:
      // button = checkPermission({
      //   // permissions: [PERMISSION.AUDIENCE.APR.ADD]
      // }) ?
      return (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.apr.name}/${routes.audience.apr.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Create New APR
        </Link>
      )
      //  : (
      //   ''
      // );
      break;
    case routes.audience.taxonomyManager.name:
      // button = <Link to={`/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.taxonomyManager.name}/${routes.audience.taxonomyManager.add}`} className="btn btn-primary tab-btn"><i className="mdi mdi-plus-box"></i>Create New Segment</Link>
      button =
        //  checkPermission({
        //   permissions: [PERMISSION.AUDIENCE.TAXONOMYMANAGER.ADD]
        // }) ?

        (
          <Link
            to={`/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.taxonomyManager.name}/${routes.audience.taxonomyManager.add}`}
            className="btn btn-primary tab-btn"
          >
            <i className="mdi mdi-plus-box"></i>Create New Segment
          </Link>
        )
      //  : (
      //   ''
      // );
      break;
    case routes.ion.tagldMapping.tagldMappingList:
      button = checkPermission({
        permissions: [PERMISSION.EXCHANGE.TAGIDMAPPING.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.ion}/${routes.ion.tagldMapping.tagldMapping}/${routes.ion.tagldMapping.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Add New
        </Link>
      ) : (
        ''
      );
      break;
    case routes.admin.agreement.name:
      button = checkPermission({
        permissions: [PERMISSION.ADMIN.AGREEMENT.ADD]
      }) ? (
        <Link
          to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.agreement.name}/${routes.admin.agreement.add}`}
          className="btn btn-primary tab-btn"
        >
          <i className="mdi mdi-plus-box"></i>Add Agreement
        </Link>
      ) : (
        ''
      );
      break;

    default:
  }
  return button;
};
export const getListWithCurrencyName = (responseList, currencyList) => {
  responseList.map((item) => {
    // logic fillTypeList
    let forbase = currencyList.find((a) => a.key == item.baseCurr);
    if (forbase) {
      item.baseCurrName = forbase.value;
    }
    let forAlternate = currencyList.find((a) => a.key == item.altCurr);
    if (forAlternate) {
      item.altCurrName = forAlternate.value;
    }
    return item;
  });
  return responseList;
};
export const renderTabContentList = ({ pathname, container }) => {
  const currentPath = pathname.substr(pathname.lastIndexOf('/') + 1);
  const isAudienceMarketPlaceActive = (tabName) => {
    switch (tabName) {
      case routes.containers.brief:
        return pathname.indexOf(`/${routes.containers.audienceMarketPlace}/${routes.containers.brief}`) > -1;
      case routes.containers.mediaPlan:
        return pathname.indexOf(`/${routes.containers.audienceMarketPlace}/${routes.containers.mediaPlan}`) > -1;
      case routes.containers.ro:
        return pathname.indexOf(`/${routes.containers.audienceMarketPlace}/${routes.containers.ro}`) > -1;
      case routes.containers.campaignCreation:
        return pathname.indexOf(`/${routes.containers.audienceMarketPlace}/${routes.containers.campaignCreation}`) > -1;
      default:
        return false;
    }
  };
  let CheckAccountType = JSON.parse(localStorage.getItem('PreSignInData'));
  let logedInTenantID = JSON.parse(localStorage.getItem('PreSignInState'));
  let findAccountType = {}
  if (CheckAccountType && CheckAccountType.responseList && CheckAccountType.responseList.length > 0 && logedInTenantID) {
    findAccountType = CheckAccountType.responseList.find((data) => data.tenantId == logedInTenantID.tenantId);
  }

  let tabContentList = '';
  switch (container) {
    case 'dashboard':
      tabContentList = (
        <>
          {/* {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD_BIDDER }) && ( */}


          <li className="nav-item">
            <Link
              to={`/${routes.mainRoute}/${routes.containers.dashboard}/${routes.dashboard.bidder.bidder}`}
              className={classNames('nav-link', {
                active: isEqual(currentPath, routes.dashboard.bidder.campaignPerformanceReport) || isEqual(currentPath, routes.dashboard.bidder.bidderReport) || isEqual(currentPath, routes.dashboard.bidder.mediaPlanningReport)
              })}
            >
              Bidder
            </Link>
          </li>
          {/* )} */}
          {/* {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD_ION }) && ( */}
          <li className="nav-item">
            <Link
              to={`/${routes.mainRoute}/${routes.containers.dashboard}/${routes.dashboard.ion.ionReport}`}
              className={classNames('nav-link', {
                active: isEqual(currentPath, routes.dashboard.ion.mediaReport) || isEqual(currentPath, routes.dashboard.ion.qpsReport) || isEqual(currentPath, routes.dashboard.ion.revenueReport) || isEqual(currentPath, routes.dashboard.ion.ionExchange)
              })}
            >
              ION
            </Link>
          </li>
          {/* )} */}
        </>
      );
      break;
      // tabContentList = (
      //   <>
      //     {checkPermission({ permissions: [PERMISSION.DASHBOARD.BIDDER.CAMPAIGNREPORT.VIEW] }) && (
      //       <li className="nav-item">
      //         <Link
      //           to={routes.dashboard.bidder.campaignPerformanceReport}
      //           className={classNames('nav-link page-header-nav', {
      //             active: isEqual(currentPath, routes.dashboard.bidder.campaignPerformanceReport)
      //           })}
      //         >
      //           Campaign Performance Report
      //         </Link>
      //       </li>
      //     )}
      //     {checkPermission({ permissions: [PERMISSION.DASHBOARD.BIDDER.BIDDERREPORT.VIEW] }) && (
      //       <li className="nav-item">
      //         <Link
      //           to={routes.dashboard.bidder.bidderReport}
      //           className={classNames('nav-link page-header-nav', {
      //             active: isEqual(currentPath, routes.dashboard.bidder.bidderReport)
      //           })}
      //         >
      //           Bidder Report
      //         </Link>
      //       </li>
      //     )}
      //     {checkPermission({ permissions: [PERMISSION.DASHBOARD.BIDDER.MEDIAPLANNIGREPORT.VIEW] }) && (
      //       <li className="nav-item">
      //         <Link
      //           to={routes.dashboard.bidder.mediaPlanningReport}
      //           className={classNames('nav-link page-header-nav', {
      //             active: isEqual(currentPath, routes.dashboard.bidder.mediaPlanningReport)
      //           })}
      //         >
      //           Media Planning Report
      //         </Link>
      //       </li>
      //     )}
      //   </>
      // );
      break;
    case 'creative':
      tabContentList = (
        <>
          {checkPermission({ permissions: [PERMISSION.CREATIVE.DISPLAY.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.creative.display.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.creative.display.name)
                })}
              >
                Display
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.CREATIVE.VIDEO.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.creative.video.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.creative.video.name)
                })}
              >
                Video
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.CREATIVE.NATIVE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.creative.native.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.creative.native.name)
                })}
              >
                Native
              </Link>
            </li>
          )}
          {/* {checkPermission({ permissions: [PERMISSION.CREATIVE.AUDIO.VIEW] }) && (<li className="nav-item">
          <Link to={routes.creative.audio.name} className={classNames('nav-link', { 'active': isEqual(currentPath, routes.creative.audio.name) })}>Audio</Link>
        </li>)} */}
          <li className="nav-item">
            <Link
              to={routes.creative.audio.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.creative.audio.name)
              })}
            >
              Audio
            </Link>
          </li>
        </>
      );
      break;

    case 'admin':
      tabContentList = (
        <>
          {checkPermission({ permissions: [PERMISSION.ADMIN.TENANT.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}`}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.tenant.name)
                })}
              >
                Tenant
              </Link>
            </li>
          )}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.SUPPLYPARTNER.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.supplyPartner.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.supplyPartner.name)
                })}
              >
                Supply Partner
              </Link>
            </li>
          )} */}
          {checkPermission({ permissions: [PERMISSION.ADMIN.PROFILE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}`}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.account.name)
                })}
              >
                Profile
              </Link>
            </li>
          )}

          {
            checkPermission({ permissions: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW] }) && checkConnectionManagementAccess() &&
            (
              <li className="nav-item">
                <Link
                  to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.connection.name}`}
                  className={classNames('nav-link page-header-nav', {
                    active: isEqual(currentPath, routes.admin.connection.name)
                  })}
                >
                  Connection Management
                </Link>
              </li>
            )
          }


          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.ACCOUNT.VIEW] }) && ( */}
          {/* <li className="nav-item">
              <Link
                to={routes.admin.account.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.account.name)
                })}
              >
                Advertider
              </Link>
            </li> */}
          {/* )} */}




          {/*
          {checkPermission({ permissions: [PERMISSION.ADMIN.VARIABLE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.currencyRate.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.currencyRate.name)
                })}
              >
                Currency Rate
              </Link>
            </li>
          )} */}
          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.VARIABLE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.platform.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.platform.name)
                })}
              >
                Platform
              </Link>
            </li>
          )} */}
          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.VARIABLE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.variable.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.variable.name)
                })}
              >
                Variable
              </Link>
            </li>
          )} */}


          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.ADVERTISER.VIEW] }) && (
            <>
               <li className="nav-item">
                <Link
                  to={routes.admin.advertiser.name}
                  className={classNames('nav-link page-header-nav', {
                    active: isEqual(currentPath, routes.admin.advertiser.name)
                  })}
                >
                  Advertiser Config
                </Link>
              </li>
               <li className="nav-item">
                <Link
                  to={routes.admin.advertiser.poc}
                  className={classNames('nav-link page-header-nav', {
                    active: isEqual(currentPath, routes.admin.advertiser.poc)
                  })}
                >
                  Advertiser POC
                </Link>
              </li>

               <li className="nav-item">
                <Link
                  to={routes.admin.advertiser.newAdvertiser}
                  className={classNames('nav-link page-header-nav', {
                    active: isEqual(currentPath, routes.admin.advertiser.newAdvertiser)
                  })}
                >
                  Advertiser Config
                </Link>
              </li>
            </>
          )} */}

          {checkPermission({ permissions: MODULE_PERMISSIONS.ADMIN_DATACONFIG }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.containers.dataConfig}`}
                className={classNames('nav-link page-header-nav', {
                  active: pathname.includes(`${routes.containers.admin}/${routes.containers.dataConfig}`)
                })}
              >
                Data Config
              </Link>
            </li>
          )}

          {checkPermission({ permissions: [PERMISSION.ADMIN.USERS.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.user.name)
                })}
              >
                User
              </Link>
            </li>
          )}

          {checkPermission({ permissions: [PERMISSION.ADMIN.SUBSCRIPTIONPLANMANAGER.VIEW] }) && findAccountType && findAccountType.hasOwnProperty("tenantType") && findAccountType.tenantType == "Platform Manager" && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.subscriptionPlanMgr.name}`}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.subscriptionPlanMgr.name)
                })}
              >
                Subscription Plan Manager
              </Link>
            </li>
          )}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.DEMANDPARTNER.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.demandPartner.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.demandPartner.name)
                })}
              >
                Demand Partner
              </Link>
            </li>
          )} */}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.FEATURES.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.features.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.features.name)
                })}
              >
                Features
              </Link>
            </li>
          )} */}
          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.ROLES.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.roles.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.roles.name)
                })}
              >
                Roles
              </Link>
            </li>
          )} */}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.AGREEMENT.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.agreement.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.agreement.name)
                })}
              >
                Agreement
              </Link>
            </li>
          )} */}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.SUPPLYPATH.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.admin.supplyPath.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.admin.supplyPath.name)
                })}
              >
                Supply Path
              </Link>
            </li>
          )} */}

          {/* <li className="nav-item">
          <Link to={routes.admin.agreement.name} className={classNames('nav-link', { 'active': isEqual(currentPath, routes.admin.agreement.name) })}>Agreement</Link>
        </li> */}

          {/* <li className="nav-item">
          <Link to={routes.admin.supplyPath.name} className={classNames('nav-link', { 'active': isEqual(currentPath, routes.admin.supplyPath.name) })}>Supply Path</Link>
        </li> */}
        </>
      );
      break;
    case 'audienceMarketPlace':
      tabContentList = (
        <>
          {checkPermission({ permissions: [PERMISSION.AUDIENCE_MARKET_PLACE.BRIEF.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.audienceMarketPlace}/${routes.containers.brief}`}
                className={classNames('nav-link page-header-nav', {
                  active: isAudienceMarketPlaceActive(routes.containers.brief)
                })}
              >
                Brief
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.AUDIENCE_MARKET_PLACE.MEDIAPLAN.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.audienceMarketPlace}/${routes.containers.mediaPlan}`}
                className={classNames('nav-link page-header-nav', {
                  active: isAudienceMarketPlaceActive(routes.containers.mediaPlan)
                })}
              >
                Media Plan
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.AUDIENCE_MARKET_PLACE.RO.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.audienceMarketPlace}/${routes.containers.ro}`}
                className={classNames('nav-link page-header-nav', {
                  active: isAudienceMarketPlaceActive(routes.containers.ro)
                })}
              >
                RO
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.AUDIENCE_MARKET_PLACE.CAMPAIGNCREATION.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={`/${routes.mainRoute}/${routes.containers.audienceMarketPlace}/${routes.containers.campaignCreation}`}
                className={classNames('nav-link page-header-nav', {
                  active: isAudienceMarketPlaceActive(routes.containers.campaignCreation)
                })}
              >
                Campaign Creation
              </Link>
            </li>
          )}
        </>
      );
      break;

    case 'dataConfig':
      tabContentList = (
        <>
          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.TENANT.VIEW] }) && ( */}
          {/* <li className="nav-item">
            <Link
              to={routes.dataConfig.platformVaraible.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.dataConfig.platformVaraible.name)
              })}
            >
              Platform Variable Mapping
            </Link>
          </li> */}
          {/* )} */}



          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.TENANT.VIEW] }) && ( */}
          <li className="nav-item">
            <Link
              to={routes.dataConfig.dspPlatform.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.dataConfig.dspPlatform.name)
              })}
            >
              DSP Platform
            </Link>
          </li>
          {/* )} */}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.TENANT.VIEW] }) && ( */}
          <li className="nav-item">
            <Link
              to={routes.dataConfig.variables.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.dataConfig.variables.name)
              })}
            >
              Variable
            </Link>
          </li>
          {/* )} */}

          {/* {checkPermission({ permissions: [PERMISSION.ADMIN.TENANT.VIEW] }) && ( */}
          {/* <li className="nav-item">
            <Link
              to={routes.dataConfig.platformTenantAdvertiser.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.dataConfig.platformTenantAdvertiser.name)
              })}
            >
              Tenant-Advertiser
            </Link>
          </li> */}
          {/* )} */}






        </>
      );
      break;

    case 'goals':
      tabContentList = (
        <>
          {/* RO functionality disabled
          {checkPermission({ permissions: [PERMISSION.RO.RO.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.containers.ro}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.containers.ro)
                })}
              >
                Goals
              </Link>
            </li>
          )}
          */}

          {/* RO functionality disabled
          {checkPermission({ permissions: [PERMISSION.UNMAPPEDCAMPAIGN.UNMAPPEDCAMPAIGN.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.containers.unmappedCampaign}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.containers.unmappedCampaign)
                })}
              >
                Unmapped Campaign
              </Link>
            </li>
          )}
          */}
        </>
      );
      break;

    case 'payment':
      tabContentList = (
        <>
          {
            findAccountType && findAccountType.hasOwnProperty("tenantType") && findAccountType.tenantType == "Platform Manager" ?
              <>
                {checkPermission({ permissions: [PERMISSION.PAYMENT.SUBSCRIPTION_PLAN.VIEW] }) && (
                  <li className="nav-item">
                    <Link
                      to={routes.payment.subscription.name}
                      className={classNames('nav-link', {
                        active: isEqual(currentPath, routes.payment.subscription.name)
                      })}
                    >
                      Subscription Plans
                    </Link>
                  </li>
                )}
                {checkPermission({ permissions: [PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW] }) && (
                  <li className="nav-item">
                    <Link
                      to={routes.payment.billingHistory.name}
                      className={classNames('nav-link', {
                        active: isEqual(currentPath, routes.payment.billingHistory.name)
                      })}
                    >
                      Payment & Transaction History
                    </Link>
                  </li>
                )}
                {checkPermission({ permissions: [PERMISSION.PAYMENT.INVOICE.VIEW] }) && (
                  <li className="nav-item">
                    <Link
                      to={routes.payment.invoice.name}
                      className={classNames('nav-link', {
                        active: isEqual(currentPath, routes.payment.invoice.name)
                      })}
                    >
                      Invoice & Billing Info
                    </Link>
                  </li>
                )}
              </> : findAccountType && findAccountType.hasOwnProperty("tenantMode") && findAccountType.hasOwnProperty("accountType") && findAccountType.accountType == 0 && findAccountType.hasOwnProperty("tenantType") && findAccountType.tenantType != "Platform Manager" && findAccountType.tenantMode == 1 ?
                <>
                  {checkPermission({ permissions: [PERMISSION.PAYMENT.SUBSCRIPTION_PLAN.VIEW] }) && (
                    <li className="nav-item">
                      <Link
                        to={routes.payment.subscription.name}
                        className={classNames('nav-link', {
                          active: isEqual(currentPath, routes.payment.subscription.name)
                        })}
                      >
                        Subscription Plans
                      </Link>
                    </li>
                  )}
                  {checkPermission({ permissions: [PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW] }) && (
                    <li className="nav-item">
                      <Link
                        to={routes.payment.billingHistory.name}
                        className={classNames('nav-link', {
                          active: isEqual(currentPath, routes.payment.billingHistory.name)
                        })}
                      >
                        Payment & Transaction History
                      </Link>
                    </li>
                  )}
                  {checkPermission({ permissions: [PERMISSION.PAYMENT.INVOICE.VIEW] }) && (
                    <li className="nav-item">
                      <Link
                        to={routes.payment.invoice.name}
                        className={classNames('nav-link', {
                          active: isEqual(currentPath, routes.payment.invoice.name)
                        })}
                      >
                        Invoice & Billing Info
                      </Link>
                    </li>
                  )}


                </> : findAccountType && findAccountType.hasOwnProperty("tenantMode") && findAccountType.hasOwnProperty("accountType") && findAccountType.accountType == 0 && findAccountType.hasOwnProperty("tenantType") && findAccountType.tenantType != "Platform Manager" && findAccountType.tenantMode == 0 ?
                  <>
                    {checkPermission({ permissions: [PERMISSION.PAYMENT.SUBSCRIPTION_PLAN.VIEW] }) && (
                      <li className="nav-item">
                        <Link
                          to={routes.payment.subscription.name}
                          className={classNames('nav-link', {
                            active: isEqual(currentPath, routes.payment.subscription.name)
                          })}
                        >
                          Subscription Plans
                        </Link>
                      </li>
                    )}
                    {checkPermission({ permissions: [PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW] }) && (
                      <li className="nav-item">
                        <Link
                          to={routes.payment.billingHistory.name}
                          className={classNames('nav-link', {
                            active: isEqual(currentPath, routes.payment.billingHistory.name)
                          })}
                        >
                          Payment & Transaction History
                        </Link>
                      </li>
                    )}
                    {checkPermission({ permissions: [PERMISSION.PAYMENT.INVOICE.VIEW] }) && (
                      <li className="nav-item">
                        <Link
                          to={routes.payment.invoice.name}
                          className={classNames('nav-link', {
                            active: isEqual(currentPath, routes.payment.invoice.name)
                          })}
                        >
                          Invoice & Billing Info
                        </Link>
                      </li>
                    )}


                  </> :
                  <>
                    {checkPermission({ permissions: [PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW] }) && (
                      <li className="nav-item">
                        <Link
                          to={routes.payment.billingHistory.name}
                          className={classNames('nav-link', {
                            active: isEqual(currentPath, routes.payment.billingHistory.name)
                          })}
                        >
                          Payment & Transaction History
                        </Link>
                      </li>
                    )}
                  </>


          }


        </>
      );
      break;
    // case 'payment':
    //   tabContentList = (
    //     <>

    //       {checkPermission({ permissions: [PERMISSION.PAYMENT.SUBSCRIPTIONS.VIEW] }) && (
    //         <li className="nav-item">
    //           <Link
    //             to={routes.payment.subscription.name}
    //             className={classNames('nav-link', {
    //               active: isEqual(currentPath, routes.payment.subscription.name)
    //             })}
    //           >
    //             Subscription Plans
    //           </Link>
    //         </li>
    //       )}
    //       {checkPermission({ permissions: [PERMISSION.PAYMENT.BILLING_HISTORY.VIEW] }) && (
    //         <li className="nav-item">
    //           <Link
    //             to={routes.payment.billingHistory.name}
    //             className={classNames('nav-link', {
    //               active: isEqual(currentPath, routes.payment.billingHistory.name)
    //             })}
    //           >
    //             Payment & Transaction History
    //           </Link>
    //         </li>
    //       )}
    //       {checkPermission({ permissions: [PERMISSION.PAYMENT.INVOICE.VIEW] }) && (
    //         <li className="nav-item">
    //           <Link
    //             to={routes.payment.invoice.name}
    //             className={classNames('nav-link', {
    //               active: isEqual(currentPath, routes.payment.invoice.name)
    //             })}
    //           >
    //             Invoice & Billing Info
    //           </Link>
    //         </li>
    //       )}
    //     </>
    //   );
    //   break;



    case 'audience':
      tabContentList = (
        <>
          {checkPermission({ permissions: [PERMISSION.AUDIENCE.AUDIENCEHIERARCHY.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.audience.audienceHierarchy.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.audience.audienceHierarchy.name)
                })}
              >
                Audience Hierarchy
              </Link>
            </li>
          )}
          {checkPermission({ permissions: [PERMISSION.AUDIENCE.HIERARCHYMANAGER.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.audience.hierarchyManager.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.audience.hierarchyManager.name)
                })}
              >
                Hierarchy Manager
              </Link>
            </li>
          )}


          {/* {checkPermission({ permissions: [PERMISSION.AUDIENCE.APR.VIEW] }) && ( */}
          {/* <li className="nav-item">
            <Link
              to={routes.audience.apr.name}
              className={classNames('nav-link page-header-nav', {
                active: isEqual(currentPath, routes.audience.apr.name)
              })}
            >
              APR
            </Link>
          </li> */}
          {/* )}


          {/* {checkPermission({ permissions: [PERMISSION.AUDIENCE.TAXONOMYMANAGER.VIEW] }) &&
          (<li className="nav-item">
            <Link to={routes.audience.taxonomyManager.add} className={classNames('nav-link', { 'active': isEqual(currentPath, routes.audience.taxonomyManager.add) })}>Taxonomy Manager</Link>
          </li>)} */}




          {checkPermission({ permissions: [PERMISSION.AUDIENCE.TAXONOMYMANAGER.VIEW] }) && (
            < li className="nav-item">
              <Link
                to={routes.audience.taxonomyManager.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.audience.taxonomyManager.name)
                })}
              >
                Taxonomy Manager
              </Link>
            </li >
          )}

          {checkPermission({ permissions: [PERMISSION.AUDIENCE.DATACAPTURE.VIEW] }) && (
            <li className="nav-item">
              <Link
                to={routes.audience.dataCapture.name}
                className={classNames('nav-link page-header-nav', {
                  active: isEqual(currentPath, routes.audience.dataCapture.name)
                })}
              >
                Data Capture
              </Link>
            </li>
          )}
        </>
      );
      break;
    default:
      return null
  }
  return tabContentList;
};

export const createDropdownOptions = (options) => {
  let dropdownOptions = [];
  options.map((option) => {
    dropdownOptions.push({
      id: option.key,
      value: option.key,
      text: option.value
    });
  });
  return dropdownOptions;
};

export const calculateRatioMedia = (width, height) => {
  const gcd = (a, b) => {
    if (b === 0) {
      return a;
    }
    return gcd(b, a % b);
  };

  const divisor = gcd(width, height);
  const ratio = `${width / divisor}:${height / divisor}`;

  return ratio;
}

export const bytesToKB = (bytes) => {
  return Math.ceil((bytes / 1024).toFixed(2));
};

export const bytesToMB = (bytes) => {
  return Math.ceil((bytes / (1024 * 1024)).toFixed(2));
};

export const bytesToGB = (bytes) => {
  return Math.ceil((bytes / (1024 * 1024 * 1024)).toFixed(2));
};

export const isTypeValid = (array, typeString) => {
  return array.some((item) =>
    typeString.toLowerCase().includes(item.toLowerCase())
  );
};

export const createFilterOptions = (options) => {
  let dropdownOptions = [];
  options.map((option) => {
    dropdownOptions.push({ key: option, value: option, text: option });
  });
  return dropdownOptions;
};

export const trendsOptions = [
  { key: 'totalAdRes', value: 'totalAdRes', text: 'Total Ad Response' },
  { key: 'totalAdReq', value: 'totalAdReq', text: 'Total Ad Request' },
  { key: 'totalAdServed', value: 'totalAdServed', text: 'Total Ad Served' },
  { key: 'totalRevenue', value: 'totalRevenue', text: 'Total Revenue' },
  { key: 'eCPM', value: 'eCPM', text: 'eCPM' }
];

export const trendsDateRangeOptions = [
  { key: '7', value: '7', text: 'Last 7 Days' },
  { key: '15', value: '15', text: 'Last 15 Days' },
  { key: 'custom', value: 'custom', text: 'Custom' }
];

export const getNativeFieldName = (name) => {
  let fieldName = '';
  switch (name) {
    case 'Native Display':
      fieldName = 'banner';
      break;
    case 'Native Video':
      fieldName = 'video';
      break;
    case 'Native Vast':
      fieldName = 'vast';
      break;
  }
  return fieldName;
};

// export const createMediaData = ({ mediaReportData, graphFilters, showHourlyFormat }) => {
//   mediaReportData = mediaReportData.sort(function compare(a, b) {
//     return new Date(a.Date) - new Date(b.Date);
//   });
//   let groupedMediaData = groupBy(mediaReportData, 'Date');
//   const { trendType } = graphFilters;
//   let hourlyFormatLabels = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'];
//   let labels = [];
//   let datasets = [];
//   let totalAdReqData = [];
//   let totalAdResData = [];
//   let totalAdServedData = [];
//   let totalRevenueData = [];
//   let eCPMData = [];

//   forEach(groupedMediaData, function (value, key) {
//     showHourlyFormat ? labels.push(moment(key, 'YYYY-MM-DD').format('MM/DD/YYYY')) : labels.push(moment(key, 'YYYY-MM-DD').format('MM/DD/YYYY'));
//     value && value.map(result => (
//       trendType && trendType.map(type => (
//         type.includes('totalAdReq') ? totalAdReqData.push(result.totalAdReq) : totalAdReqData,
//         type.includes('totalAdRes') ? totalAdResData.push(result.totalAdRes) : totalAdResData,
//         type.includes('totalAdServed') ? totalAdServedData.push(result.totalAdServed) : totalAdServedData,
//         type.includes('totalRevenue') ? totalRevenueData.push(result.totalRevenue) : totalRevenueData,
//         type.includes('eCPM') ? eCPMData.push(result.eCPM) : eCPMData
//       ))
//     ));
//   });

//   datasets = [{
//     label: 'Total Ad Response',
//     fill: false,
//     borderColor: 'rgba(75,192,192,1)',
//     pointBorderColor: 'rgba(75,192,192,1)',
//     pointHoverBackgroundColor: 'rgba(75,192,192,1)',
//     pointRadius: 1,
//     data: totalAdResData,
//   },
//   {
//     label: 'Total Ad Request',
//     fill: false,
//     borderColor: 'rgba(202, 55, 2, 1)',
//     pointBorderColor: 'rgba(202, 55, 2, 1)',
//     pointHoverBackgroundColor: 'rgba(202, 55, 2, 1)',
//     pointRadius: 1,
//     data: totalAdReqData,
//   },
//   {
//     label: 'Total Ad Served',
//     fill: false,
//     borderColor: 'rgba(1, 45, 116, 1)',
//     pointBorderColor: 'rgba(1, 45, 116, 1)',
//     pointHoverBackgroundColor: 'rgba(1, 45, 116, 1)',
//     pointRadius: 1,
//     data: totalAdServedData,
//   },
//   {
//     label: 'Total Revenue',
//     fill: false,
//     borderColor: 'rgba(255, 0, 255, 1)',
//     pointBorderColor: 'rgba(255, 0, 255, 1)',
//     pointHoverBackgroundColor: 'rgba(255, 0, 255, 1)',
//     pointRadius: 1,
//     data: totalRevenueData,
//   },
//   {
//     label: 'eCPM',
//     fill: false,
//     borderColor: 'rgba(168, 152, 50, 1)',
//     pointBorderColor: 'rgba(168, 152, 50, 1)',
//     pointHoverBackgroundColor: 'rgba(168, 152, 50, 1)',
//     pointRadius: 1,
//     data: eCPMData,
//   }
//   ]
//   return {
//     labels,
//     datasets
//   }
// }

export const createMediaData = (mediaReportData, trendType = []) => {
  let sum = [];
  let labels = [];

  mediaReportData = mediaReportData.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });

  let mediaReportDataList = groupBy(mediaReportData, 'Date');
  Object.keys(mediaReportDataList).forEach((date) => {
    labels.push(moment(date, 'YYYY-MM-DD').format('D-MMM-YY'));
  });
  trendType.map((item) => {
    let sum1 = [];
    Object.keys(mediaReportDataList).forEach((date) => {
      sum1.push(_.sumBy(mediaReportDataList[date], function (o) {
        return parseFloat(o[item.key]);
      }).toFixed(2)
      );
      // sum1.push(_.sumBy(mediaReportDataList[date], function (o) { return parseInt(o[item.key]) }));
    });
    sum.push(sum1);
  });

  let options = {
    height: 300,
    // chartPadding: {
    //   top: 20,
    //   right: 50,
    //   bottom: 30,
    //   left: 50
    // },
    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    showPoint: true,
    plugins: []
  };

  let chartData = { labels: labels, series: sum };

  return { chartData, options };
};

// export const createQps1Data = ({ qpsReportData }) => {
//   let groupedQPSData = groupBy(qpsReportData, 'date');

//   let labels = [];
//   let qpsData = [];
//   let datasets = [];
//   let color = 'rgba(51,102,255,0.2)';
//   qpsReportData && qpsReportData.map(result => (
//     labels.push(moment(result.date, 'YYYY-MM-DD').format('MM/DD/YYYY')),
//     qpsData.push(result.qps)
//   ));
//   forEach(groupedQPSData, function (value, key) {
//     labels.push(key);
//     value && value.map(result => (
//       qpsData.push(result.qps)
//     ));
//   });
//   datasets = [{
//     label: 'QPS',
//     fill: false,
//     borderColor: color,
//     pointBorderColor: 'rgba(51,0,204,0.2)',
//     pointHoverBackgroundColor: color,
//     backgroundColor: color,
//     pointRadius: 1,
//     data: qpsData
//   }];
//   return {
//     labels,
//     datasets
//   }
// }

export const createQpsData = ({ qpsReportData }) => {
  let sum = [];
  let labels = [];

  qpsReportData = qpsReportData.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });

  let qpsReportDataList = groupBy(qpsReportData, 'date');

  Object.keys(qpsReportDataList).forEach((date) => {
    labels.push(moment(date, 'YYYY-MM-DD').format('D-MMM-YY'));
  });

  Object.keys(qpsReportDataList).forEach((date) => {
    sum.push(_.sumBy(qpsReportDataList[date], function (o) {
      return parseFloat(o.qps);
    }).toFixed(2)
    );
    // sum.push(_.sumBy(qpsReportDataList[date], function (o) { return parseInt(o.qps) }));
  });

  let options = {
    height: 300,

    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    showPoint: true,
    plugins: []
  };

  let chartData = { labels: labels, series: [sum] };

  return { chartData, options };
};

// export const createRevenueData = ({ revenueReportData }) => {
//   let groupedRevenueData = groupBy(revenueReportData, 'date');
//   let labels = [];
//   let datasets = [];
//   let color = '';
//   forEach(groupedRevenueData, function (value, key) {
//     labels.push(key);
//     value && value.map(result => (
//       color = random_rgba(),
//       datasets.push({
//         label: result.partner,
//         fill: false,
//         backgroundColor: color,
//         borderColor: color,
//         pointRadius: 1,
//         data: [result.totalRevenue]
//       })
//     ));
//   });
//   return {
//     labels,
//     datasets
//   }
// }

export const createRevenueData = ({ revenueReportData, partnerNameList }) => {
  let labels = [];
  let series = [];

  revenueReportData = revenueReportData.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });

  let revenueReportDataList = groupBy(revenueReportData, 'date');

  Object.keys(revenueReportDataList).forEach((date) => {
    labels.push(date);
  });

  partnerNameList.forEach((item) => {
    let sum = [];
    Object.keys(revenueReportDataList).forEach((date) => {
      sum.push(_.sumBy((revenueReportDataList[date] || [{ totalRevenue: 0 }]).filter((a) => a.partner === item),
        function (o) {
          return parseFloat(o.totalRevenue);
        }).toFixed(2)
      );
      // sum.push(_.sumBy((revenueReportDataList[date] || [{ totalRevenue: 0 }]).filter(a => a.partner === item), function (o) { return parseInt(o.totalRevenue) }));
    });
    series.push(sum);
  });

  let options = {
    height: 300,
    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    plugins: []
  };

  const chartData = { labels, series };
  return {
    chartData,
    options
  };
};

export const bidderReportData = (bidderReport) => {
  let series = [];
  let labels = [];
  let data = bidderReport;
  let bidWon = [];
  let totalRequest = [];
  let totalResponse = [];
  let totalBusinessReq = [];
  let totalBusinessResp = [];

  let options = {
    height: 300,
    // chartPadding: {
    //   top: 20,
    //   right: 50,
    //   bottom: 30,
    //   left: 70
    // },
    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    plugins: []
  };

  bidderReport = bidderReport.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });
  let bidderReportData = groupBy(data, 'date');

  Object.keys(bidderReportData).forEach((date) => {
    labels.push(moment(date, 'YYYY-MM-DD').format('D-MMM-YY'));
    bidWon.push(
      _.sumBy(bidderReportData[date], function (o) {
        return parseFloat(o.bidWon);
      }).toFixed(2)
    );
    // bidWon.push(_.sumBy(bidderReportData[date], function (o) { return parseInt(o.bidWon); }));
    totalRequest.push(
      _.sumBy(bidderReportData[date], function (o) {
        return parseFloat(o.totalRequest);
      }).toFixed(2)
    );

    totalBusinessReq.push(
      _.sumBy(bidderReportData[date], function (o) {
        return parseFloat(o.totalBusinessReq);
      }).toFixed(2)
    );

    // totalRequest.push(_.sumBy(bidderReportData[date], function (o) { return parseInt(o.totalRequest); }));
    totalResponse.push(
      _.sumBy(bidderReportData[date], function (o) {
        return parseFloat(o.totalResponse);
      }).toFixed(2)
    );
    // totalResponse.push(_.sumBy(bidderReportData[date], function (o) { return parseInt(o.totalResponse); }));

    totalBusinessResp.push(
      _.sumBy(bidderReportData[date], function (o) {
        return parseFloat(o.totalBusinessResp);
      }).toFixed(2)
    );
  });
  series.push(totalRequest);
  series.push(totalBusinessReq);
  series.push(totalResponse);
  series.push(totalBusinessResp);
  series.push(bidWon);
  const chartData = { labels, series };
  return {
    chartData,
    options
  };
};

export const mediaPlanningReportData = (mediaPlanningReport, trendsName) => {
  let sum = [];
  let totalBusinessReq = [];
  let labels = [];

  mediaPlanningReport = mediaPlanningReport.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });

  let mediaPlanningReportData = groupBy(mediaPlanningReport, 'date');

  Object.keys(mediaPlanningReportData).forEach((date) => {
    labels.push(moment(date, 'YYYY-MM-DD').format('D-MMM-YY'));
    // sum.push(_.sumBy(mediaPlanningReportData[date], function (o) { return parseInt(o.totalRequest); }));
    sum.push(
      _.sumBy(mediaPlanningReportData[date], function (o) {
        return parseFloat(o[trendsName]);
      }).toFixed(2)
    );
    // totalBusinessReq.push(_.sumBy(mediaPlanningReportData[date], function (o) { return parseFloat(o.totalBusinessReq); }).toFixed(2));
  });

  let options = {
    height: 300,
    // chartPadding: {
    //   top: 20,
    //   right: 50,
    //   bottom: 30,
    //   left: 50
    // },
    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    showPoint: true,
    plugins: []
  };

  if (labels && labels.length === 1) {
    labels = ['', ...labels];
    sum = [null, ...sum];
    totalBusinessReq = [null, ...totalBusinessReq];
  }

  var chartData = {
    labels: labels,
    series: [sum, totalBusinessReq]
  };
  return {
    chartData,
    options
  };
};
export const campaignPerformanceReportData = (campaignPerformanceReport, trendsName) => {
  let sum = [];
  let labels = [];

  campaignPerformanceReport = campaignPerformanceReport.sort(function compare(a, b) {
    return new Date(a.date) - new Date(b.date);
  });

  let campaignPerformanceReportData = groupBy(
    campaignPerformanceReport,
    'date'
  );

  Object.keys(campaignPerformanceReportData).forEach((date) => {
    labels.push(moment(date, 'YYYY-MM-DD').format('D-MMM-YY'));
    sum.push(
      _.sumBy(campaignPerformanceReportData[date], function (o) {
        return parseFloat(o[trendsName]);
      }).toFixed(2) || 0
    );
  });

  let options = {
    height: 300,
    // chartPadding: {
    //   top: 20,
    //   right: 50,
    //   bottom: 30,
    //   left: 50
    // },
    // X-Axis specific configuration
    axisX: {
      // We can disable the grid for this axis
      showGrid: false
    },

    // Y-Axis specific configuration
    axisY: {
      // Lets offset the chart a bit from the labels
      offset: 60
    },
    showPoint: true,
    plugins: []
  };

  var chartData = {
    labels: labels,
    series: [sum]
  };

  return {
    chartData,
    options
  };
};

export const campaignListAllReportData = (campaignListAllReportData = [], goalTypeList, pacingList, recActiveList, osList, browserList, deviceTypeList, creativeType) => {
  const data = campaignListAllReportData.map((item) => {
    let startDate;
    let endDate;
    let advertisername;
    let goal = '';
    let pacingStyle = '';
    let response;
    let click;
    let ctr;
    let impression;
    let recActiveName = '';
    let date = '';
    // logic for get startdate and enddate
    if (item.flight && item.flight.length) {
      startDate = item.flight[0].startDate;
      endDate = item.flight[0].endDate;
    }
    // logic for get response and click
    if (item.pi && item.pi.length) {
      response = item.pi[0].response;
      click = item.pi[0].click;
      impression = item.pi[0].impression;
      ctr = item.pi[0].ctr;
    }

    // logic goal
    let goalType = goalTypeList.find((a) => a.key == item.goal);
    if (goalType) {
      goal = goalType.value;
    }

    // logic pacingStyle
    let pacing = pacingList.find((a) => a.id == item.pacingStyle);
    if (pacing) {
      pacingStyle = pacing.value;
    }
    if (item.adContentType == 0) {
      item.creativeTypeName = "Display";
    }
    if (item.adContentType == 1) {
      item.creativeTypeName = "Native";
    }
    if (item.adContentType == 2) {
      item.creativeTypeName = "Video";
    }
    if (item.adContentType == 3) {
      item.creativeTypeName = "Audio";
    }
    // logic recActive
    let Active = recActiveList.find((a) => a.id == item.recActive);
    if (Active) {
      recActiveName = Active.value;
    }

    let dealIdName = (item.pmp || []).map((a) => a.dealId);
    item.dealIdNameDetail = dealIdName; // use for component render
    item.dealIdName = dealIdName.toString(); // sorting

    // logic Strategies
    let strategies = item.strategies.map((value) => {
      let strategiesClick = '';
      let strategiesResponse = '';
      let strategiesImpression = '';
      let strategiesCtr = '0%';
      let strategiesRecActive = '';

      // logic for get response and click
      if (value.pi && value.pi.length) {
        strategiesResponse = value.pi[0].response;
        strategiesClick = value.pi[0].click;
        strategiesImpression = value.pi[0].impression;
        strategiesCtr = value.pi[0].impression ? `${((value.pi[0].click / value.pi[0].impression) * 100).toFixed(2)}%` : `${0}%`;
      }
      value.strategiesBidCost = `${value.minimumBid} - ${value.maximumBid}`;

      // logic recActive
      let active = recActiveList.find((a) => a.id == value.recActive);

      if (active) {
        strategiesRecActive = active.value;
      }
      value.filter = value.filter || [];

      // logic  os
      let osMatch = [];
      value.filter.forEach((a) => {
        let os = osList.find((b) => b.key === (a.filter || '').toString());
        if (os) {
          osMatch.push(os);
        }
      });

      let strategyParams = [];
      if (osMatch.length) {
        if (osMatch.length == osList.length) {
          strategyParams = ['All'];
        } else {
          osMatch.forEach((a) => {
            strategyParams.push(a.value);
          });
        }
      } else {
        strategyParams = ['All'];
      }

      // logic browserMatch
      let browserMatch = [];
      value.filter.forEach((a) => {
        let browser = browserList.find((b) => b.key === (a.filter || '').toString());
        if (browser) {
          browserMatch.push(browser);
        }
      });
      let browserData = [];
      if (browserMatch.length) {
        if (browserMatch.length == browserList.length) {
          browserData = ['All'];
        } else {
          browserMatch.forEach((a) => {
            browserData.push(a.value);
          });
        }
      } else {
        browserData = ['All'];
      }
      value.browserDataDetail = browserData;
      value.browserData = browserData.toString();

      // logic deviceTypeMatch
      let deviceTypeMatch = [];

      value.filter.forEach((a) => {
        let deviceType = deviceTypeList.find((b) => b.key === (a.filter || '').toString());
        if (deviceType) {
          deviceTypeMatch.push(deviceType);
        }
      });

      let deviceTypeData = [];
      if (deviceTypeMatch.length) {
        if (deviceTypeMatch.length == deviceTypeList.length) {
          deviceTypeData = ['All'];
        } else {
          deviceTypeMatch.forEach((a) => {
            deviceTypeData.push(a.value);
          });
        }
      } else {
        deviceTypeData = ['All'];
      }

      value.deviceTypeDataDetail = deviceTypeData;
      value.deviceTypeData = deviceTypeData.toString();

      value.strategyParamsDetail = strategyParams;
      value.strategyParams = strategyParams.toString();
      return {
        ...value,
        strategiesResponse,
        strategiesClick,
        strategiesCtr,
        strategiesImpression,
        strategiesRecActive
      };
    });

    if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
      date = item.modifyRecDetails.dateTime;
    } else if (item.createRecDetails && item.createRecDetails.dateTime) {
      date = item.createRecDetails.dateTime;
    }

    return {
      ...item,
      startDate,
      endDate,
      advertisername,
      goal,
      pacingStyle,
      response,
      click,
      recActiveName,
      date,
      strategies,
      impression,
      ctr
    };
  });
  return data;
};

export const supplyPartnerListAllReportData = (SupplyPartnerListData, dataObj) => {
  const { integrationTypeList } = dataObj;
  let data = SupplyPartnerListData.map((item) => {
    let integrationTypeId;
    let active;

    if (integrationTypeList && integrationTypeList.length && item.integrationTypeId) {
      let integration = integrationTypeList.find(
        (a) => a.key === item.integrationTypeId.toString()
      );
      if (integration) {
        integrationTypeId = integration.value;
      }
    }

    active = active ? 'Active' : 'Inactive';
    return { ...item, active, integrationTypeId };
  });
  return data;
};

export const demandPartnerListAllReportData = (demandPartnerListData, dataObj) => {
  demandPartnerListData.map((item) => {
    let deviceList = item.devicesSupported ? item.devicesSupported.split(',') : [];

    // logic fillTypeList
    let fillObj = dataObj.fillTypeList.find((a) => a.key == item.fillTypeId);
    if (fillObj) {
      item.fillTypeName = fillObj.value;
    }

    // logic devicesSupportedList
    item.deviceNameList = [];
    if (deviceList && deviceList.length) {
      deviceList.forEach((a) => {
        let deviceObj = dataObj.devicesSupportedList.find((b) => b.key == a);
        if (deviceObj) {
          item.deviceNameList.push(deviceObj.value);
        }
      });
    }

    item.deviceNameDetail = item.deviceNameList; // use for component render
    item.deviceNameName = item.deviceNameList.toString(); // sorting

    // logic countryName
    item.countryName = [];
    if (item.geos && item.geos.length) {
      item.geos.forEach((a) => {
        let match = dataObj.countryList.find((b) => b.id == a.countryId);
        if (match) {
          item.countryName.push(match.countryName);
        }
      });
    }

    item.countryNameDetail = item.countryName; // use for component render
    item.countryName = item.countryName.toString(); // sorting

    item.creativeNameList = [];
    item.bannerSizeName = [];
    item.videoSizeName = [];
    item.nativeBannerSizeName = [];
    item.nativeVideoSizeName = [];
    if (item.adFormats && item.adFormats.length) {
      // logic creativeName
      item.adFormats.forEach((a) => {
        let match = dataObj.creativeTypeList.find((b) => b.key == a.creativeTypeId);
        if (match) {
          item.creativeNameList.push(match.value);
        }
      });

      item.creativeNameDetail = _.uniq(item.creativeNameList); // use for component render
      item.creativeName = item.creativeNameList.toString(); // sorting

      // logic bannerSizeName
      item.adFormats.forEach((a) => {
        (a.adSizeIds || []).forEach((b) => {
          let match = dataObj.bannerSizeList.find((c) => c.key == b);
          if (match) {
            item.bannerSizeName.push(match.value);
          }
        });
      });

      item.bannerSizeNameDetail = item.bannerSizeName; // use for component render
      item.bannerSizeName = item.bannerSizeName.toString(); // sorting

      // logic videoSizeName
      item.adFormats.forEach((a) => {
        (a.adSizeIds || []).forEach((b) => {
          let match = dataObj.videoSizeList.find((c) => c.key == b);
          if (match) {
            item.videoSizeName.push(match.value);
          }
        });
      });

      item.videoSizeNameDetail = item.videoSizeName; // use for component render
      item.videoSizeName = item.videoSizeName.toString(); // sorting

      // logic nativeBannerSizeName
      item.adFormats.forEach((a) => {
        (a.adSizeIds || []).forEach((b) => {
          let match = dataObj.nativeBannerSizeList.find((c) => c.key == b);
          if (match) {
            item.nativeBannerSizeName.push(match.value);
          }
        });
      });

      item.nativeBannerSizeNameDetail = item.nativeBannerSizeName; // use for component render
      item.nativeBannerSizeName = item.nativeBannerSizeName.toString(); // sorting

      // logic nativeVideoSizeName
      item.adFormats.forEach((a) => {
        (a.adSizeIds || []).forEach((b) => {
          let match = dataObj.nativeVideoSizeList.find((c) => c.key == b);
          if (match) {
            item.nativeVideoSizeName.push(match.value);
          }
        });
      });
    }

    item.nativeVideoSizeNameDetail = item.nativeVideoSizeName; // use for component render
    item.nativeVideoSizeName = item.nativeVideoSizeName.toString(); // sorting

    return item;
  });
  return demandPartnerListData;
};

export const mediationTemplateNameListAllReportData = (mediationFlow, demandpartnerSeatList, pmpList, mediationTypeList, auctionTypeList) => {
  let data = [];

  // data = groupBy(mediationFlow, 'mfMediationType');
  data = groupBy(mediationFlow, 'mfSeqGroupNos');
  // data = groupBy(mediationFlow, 'seqNoFromUI');



  let mediationList = [];
  Object.keys(data).forEach((a) => {
    let commonRecord = data[a][0];

    // logic partnerTypeName
    let partnerTypeName = [];
    let mediationType = mediationTypeList.find(
      (a) => a.key == commonRecord.mfMediationType
    );
    if (mediationType) {
      partnerTypeName.push(mediationType.value);
    }

    let auctionName = '';
    let auction = auctionTypeList.find(
      (a) => a.id == commonRecord.mtAuctionType
    );
    if (auction) {
      auctionName = auction.value;
    }

    // logic pmpName
    let pmpName = [];
    let pmp = pmpList.find((a) => a.pmpId == commonRecord.mfPMPId);
    if (pmp) {
      pmpName.push(pmp.pmpName);
    }

    let mediation = {
      mfSeqGroupNos: a,
      mfFloorPrice: commonRecord.mfFloorPrice,
      mfHeadTag: commonRecord.mfHeadTag,
      mfBodyTag: commonRecord.mfBodyTag,
      partnerTypeNameDetail: partnerTypeName,
      partnerTypeName: partnerTypeName.toString(),
      pmpNameDetail: pmpName,
      pmpName: pmpName.toString(),
      auctionName
    };

    let demandPartnerName = [];
    let countryName = [];

    (data[a] || []).map((item) => {
      // logic demandPartnerName
      // let demandpartner = demandpartnerList.find((a) => a.demandPartnerId == item.mfDemandPartnerId)
      // if (demandpartner) {
      //   demandPartnerName.push(demandpartner.demandPartnerName)
      // }
      let demandpartner = demandpartnerSeatList.find(
        (a) => a.seatId == item.mfDemandPartnerId
      );
      if (demandpartner) {
        demandPartnerName.push(demandpartner.demandPartnerName);
      }
      // logic countryName

      if (item.mediationFlowDetails && item.mediationFlowDetails.length) {
        item.mediationFlowDetails.forEach((a) => {
          // if (a.catVariableType == 1) {
          //   let country = countryList.find((b) => b.id == a.catVariable);
          //   if (country) {
          //     countryName.push(country.countryName);
          //   }
          // } else if (a.catVariableType == 2) {
          //   let state = getStateAllList.find((b) => b.id == a.catVariable);
          //   if (state) {
          //     countryName.push(state.stateName);
          //   }
          // } else if (a.catVariableType == 3) {
          //   let city = getCityAllList.find((b) => b.id == a.catVariable);
          //   if (city) {
          //     countryName.push(city.cityName);
          //   }
          // }
          if (a.catValue) {
            countryName.push(a.catValue);
          }
        });
      }
      return item;
    });

    mediation.demandPartnerNameDetail = _.uniqBy(demandPartnerName);
    mediation.demandPartnerName = _.uniqBy(demandPartnerName).toString();

    mediation.countryNameDetail = _.uniqBy(countryName);
    mediation.countryName = _.uniqBy(countryName).toString();

    mediationList.push(mediation);
  });
  return mediationList;
  // return mediationList.reverse();
};

export const mediationTemplateNameListAllReportRoadblockData = (mediationFlow, demandpartnerSeatList, pmpList, mediationTypeList, auctionTypeList) => {
  let data = [];
  let roadblockList = mediationFlow.map((item, index) => ({ ...item, seqNoFromUI: index }))
  // data = groupBy(mediationFlow, 'mfMediationType');
  // data = groupBy(mediationFlow, 'mfSeqGroupNos');
  data = groupBy(roadblockList, 'seqNoFromUI');



  let mediationList = [];
  Object.keys(data).forEach((a) => {
    let commonRecord = data[a][0];

    // logic partnerTypeName
    let partnerTypeName = [];
    let mediationType = mediationTypeList.find(
      (a) => a.key == commonRecord.mfMediationType
    );
    if (mediationType) {
      partnerTypeName.push(mediationType.value);
    }

    let auctionName = '';
    let auction = auctionTypeList.find(
      (a) => a.id == commonRecord.mtAuctionType
    );
    if (auction) {
      auctionName = auction.value;
    }

    // logic pmpName
    let pmpName = [];
    let pmp = pmpList.find((a) => a.pmpId == commonRecord.mfPMPId);
    if (pmp) {
      pmpName.push(pmp.pmpName);
    }

    let mediation = {
      mfSeqGroupNos: a,
      mfFloorPrice: commonRecord.mfFloorPrice,
      mfHeadTag: commonRecord.mfHeadTag,
      mfBodyTag: commonRecord.mfBodyTag,
      partnerTypeNameDetail: partnerTypeName,
      partnerTypeName: partnerTypeName.toString(),
      pmpNameDetail: pmpName,
      pmpName: pmpName.toString(),
      auctionName
    };

    let demandPartnerName = [];
    let countryName = [];

    (data[a] || []).map((item) => {
      let demandpartner = demandpartnerSeatList.find(
        (a) => a.seatId == item.mfDemandPartnerId
      );
      if (demandpartner) {
        demandPartnerName.push(demandpartner.demandPartnerName);
      }
      // logic countryName

      if (item.mediationFlowDetails && item.mediationFlowDetails.length) {
        item.mediationFlowDetails.forEach((a) => {
          if (a.catValue) {
            countryName.push(a.catValue);
          }
        });
      }
      return item;
    });

    mediation.demandPartnerNameDetail = _.uniqBy(demandPartnerName);
    mediation.demandPartnerName = _.uniqBy(demandPartnerName).toString();

    mediation.countryNameDetail = _.uniqBy(countryName);
    mediation.countryName = _.uniqBy(countryName).toString();

    mediationList.push(mediation);
  });
  return mediationList;
  // return mediationList.reverse();
};

export const seatData = (pmpSeatList, { currencyList, demandpartnerSeatList }) => {
  let data = [];
  data = (pmpSeatList || []).map((item) => {
    // logic Currency Name
    if (currencyList && currencyList.length) {
      let currencyObj = currencyList.find((a) => parseInt(a.key || '') === parseInt(item.currency || ''));
      if (currencyObj) {
        item.currencyName = currencyObj.value;
      } else {
        item.currencyName = '';
      }
    }

    // logic Demandpartner Name
    if (demandpartnerSeatList && demandpartnerSeatList.length) {
      let demandpartnerObj = demandpartnerSeatList.find((a) => parseInt(a.seatId || '') === parseInt(item.seatId || ''));
      if (demandpartnerObj) {
        item.demandpartnerName = demandpartnerObj.demandPartnerName;
      }
    }

    return item;
  });

  return data;
};

export const creativeDisplayListAllReportData = (creativeDisplayListData, bannerSize, recActiveList, creativeTypeList) => {
  let data = creativeDisplayListData.map((item) => {
    let recActiveName;
    let creativeType;
    let advertiserIdName;

    // logic recActiveName
    let Active = recActiveList.find((a) => a.id === item.recActive);
    if (Active) {
      recActiveName = Active.value;
    }

    // logic creativeType
    if (item.creativeType) {
      let creative = creativeTypeList.find((a) => a.key === item.creativeType.toString());
      if (creative) {
        creativeType = creative.value;
      } else {
        creativeType = '';
      }
    }

    let tagDisplay = item.tagDisplay.map((value) => {
      let adSizesList = [];
      adSizesList = value.adSizes.split(',');

      //logic recActive
      let active = recActiveList.find((a) => a.id === value.recActive);
      if (active) {
        value.displayRecActive = active.value;
      }

      // logic adSize
      let adSizeNameList = [];
      adSizesList.forEach((a) => {
        let adSize = bannerSize.find((b) => b.key == a);
        if (adSize) {
          adSizeNameList.push(adSize.value);
        }
      });

      value.adSizeNameListDetail = adSizeNameList; // use for component render
      value.adSizeNameList = adSizeNameList.toString(); // sorting

      // logic createRecDetails
      if (value.createRecDetails && value.createRecDetails.dateTime) {
        value.createRecDetailsDateTime = value.createRecDetails.dateTime;
      }

      // logic modifyRecDetailsDateTime
      if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
        value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
      } else if (value.createRecDetails && value.createRecDetails.dateTime) {
        value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
      }
      value.fileUrl = value.tagUrl;
      value.tagUrl = 'Tag';
      value.landingUrl = 'Tag';
      return value;
    });

    let display = (item.display || []).map((value) => {
      //logic recActive
      let active = recActiveList.find((a) => a.id === value.recActive);
      if (active) {
        value.displayRecActive = active.value;
      }

      // logic adSize
      let adSizeNameList = [];
      let adSize = bannerSize.find((b) => b.key == value.adSize);
      if (adSize) {
        adSizeNameList.push(adSize.value);
      }

      value.adSizeNameListDetail = adSizeNameList; // use for component render
      value.adSizeNameList = adSizeNameList.toString(); // sorting

      // logic createRecDetails
      if (value.createRecDetails && value.createRecDetails.dateTime) {
        value.createRecDetailsDateTime = value.createRecDetails.dateTime;
      }

      // logic modifyRecDetailsDateTime
      if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
        value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
      } else if (value.createRecDetails && value.createRecDetails.dateTime) {
        value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
      }
      value.tagId = value.displayId;
      value.tagUrl = <img src={value.fileUrl} />;
      value.fileUrl = value.fileUrl;
      return value;
    });

    item.tagNativeData = [...tagDisplay, ...display];
    return {
      ...item,
      recActiveName,
      creativeType,
      advertiserIdName,
      tagDisplay
    };
  });
  return data;
};

export const creativeVideoListAllReportData = (creativeVideoListData, videoSize, recActiveList, creativeTypeList) => {
  creativeVideoListData.map((item) => {
    // logic recActiveName
    let Active = recActiveList.find((a) => a.id === item.recActive);
    if (Active) {
      item.recActiveName = Active.value;
    }

    // logic creativeType
    if (item.creativeType) {
      let creative = creativeTypeList.find((a) => a.key === item.creativeType.toString());
      if (creative) {
        item.creativeType = creative.value;
      } else {
        item.creativeType = '';
      }
    }

    let tagVideo = [];
    if (item.tagVideo && item.tagVideo.length) {
      tagVideo = item.tagVideo.map((value) => {
        let adSizesList = [];

        if (value.adSizes) {
          adSizesList = value.adSizes.split(',');
        }
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.VideoRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeVideoNameList = [];
        adSizesList.forEach((a) => {
          let adSize = videoSize.find((b) => b.key == a);
          if (adSize) {
            adSizeVideoNameList.push(adSize.value);
          }
        });

        value.adSizeVideoNameListDetail = adSizeVideoNameList; // use for component render
        value.adSizeVideoNameList = adSizeVideoNameList.toString(); // sorting
        value.fileUrl = value.tagUrl || '';
        // value.landingPageUrl = item.tagVideo[0].landingPageUrl
        // value.clickUrl = item.tagVideo[0].clickUrl
        // value.tagUrl = 'Tag';
        // value.landingPageUrl = 'Tag';
        value.isTag = true;
        return value;
      });
    }

    let video = [];
    if (item.video && item.video.length) {
      video = item.video.map((value) => {
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.VideoRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeVideoNameList = [];
        let adSize = videoSize.find((b) => b.key == value.adSize);
        if (adSize) {
          adSizeVideoNameList.push(adSize.value);
        }

        value.adSizeVideoNameListDetail = adSizeVideoNameList; // use for component render
        value.adSizeVideoNameList = adSizeVideoNameList.toString(); // sorting
        // value.tagUrl = <img src={value.fileUrl} />;
        value.tagUrl = value.fileUrl;
        value.fileUrl = value.fileUrl;
        value.tagId = value.videoId;
        value.isTag = false;
        return value;
      });
    }
    let videoWrapper = [];
    if (item.videoWrapper && item.videoWrapper.length) {
      videoWrapper = item.videoWrapper.map((value) => {
        return value;
      });
    }
    // item.clickUrl = video.length > 0 ? video[0].clickUrl : ''
    // item.landingPageUrl = video.length > 0 ? video[0].landingPageUrl : videoWrapper.length > 0 ? videoWrapper[0].landingPageUrl : ''
    // item.fileUrl = video.length > 0 ? video[0].fileUrl : videoWrapper.length > 0 ? videoWrapper[0].url : ''
    // item.sourceFile = video.length > 0 ? video[0].fileUrl.replace(/^.*[\\\/]/, '') : videoWrapper.length > 0 ? videoWrapper[0].url.replace(/^.*[\\\/]/, '') : ''

    var serviceFiles = [];
    if (item.videoType === 1 || item.videoType === 0) {
      serviceFiles = item.fileType === 1 ? tagVideo : video;
      item.clickUrl = item.fileType == 1 ? tagVideo.length > 0 ? tagVideo[0].clickUrl : '' : video.length > 0 ? video[0].clickUrl : '';
      item.landingPageUrl = item.fileType == 1 ? tagVideo.length > 0 ? tagVideo[0].landingPageUrl : '' : video.length > 0 ? video[0].landingPageUrl : '';
      // item.fileUrl = item.fileType == 1 ? tagVideo.length > 0 ? tagVideo[0].fileUrl : '' : video.length > 0 ? video[0].fileUrl : ''
      // item.sourceFile = item.fileType == 1 ? tagVideo.length > 0 ? tagVideo[0].fileUrl.replace(/^.*[\\\/]/, '') : '' : video.length > 0 ? video[0].fileUrl.replace(/^.*[\\\/]/, '') : ''
    }
    // if (item.videoType === 0) {
    //   // var serviceFiles = tagVideo.filter((item) => item.fileType === 1)
    //   serviceFiles = video
    //   item.clickUrl = video.length > 0 ? video[0].clickUrl : ''
    //   item.landingPageUrl = video.length > 0 ? video[0].landingPageUrl : ''
    //   item.fileUrl = video.length > 0 ? video[0].fileUrl : ''
    //   item.sourceFile = video.length > 0 ? video[0].fileUrl.replace(/^.*[\\\/]/, '') : ''
    // }
    if (item.videoType === 2) {
      item.landingPageUrl = videoWrapper.length > 0 ? videoWrapper[0].landingPageUrl : '';
    }

    var creativeTrackers = item.creativeTrackers ? item.creativeTrackers.filter((item) => item.category === 1) : [];
    // let type = item.tagVideo.length ? 'tag' : item.videoWrapper !== undefined && item.videoWrapper.length ? 'VAST TAG' : 'file'
    let type = item.videoType === 0 ? 'FILE HTML' : item.videoType === 1 ? 'FILE VAST' : 'VAST TAG';
    item.tagNativeData = [...video, ...tagVideo];
    item.trackerEventsCount = creativeTrackers.length;
    item.serviceFilesCount = serviceFiles.length;
    item.type = type;
    return item;
  });
  return creativeVideoListData;
};

export const creativeAudioListAllReportData = (creativeAudioListData, audioSize, recActiveList, creativeTypeList) => {
  creativeAudioListData.map((item) => {
    // logic recActiveName
    let Active = recActiveList.find((a) => a.id === item.recActive);
    if (Active) {
      item.recActiveName = Active.value;
    }

    // logic creativeType
    if (item.creativeType) {
      let creative = creativeTypeList.find((a) => a.key === item.creativeType.toString());
      if (creative) {
        item.creativeType = creative.value;
      } else {
        item.creativeType = '';
      }
    }

    let audio = [];
    if (item.audio && item.audio.length) {
      audio = item.audio.map((value) => {
        let adSizesList = [];

        if (value.adSizes) {
          adSizesList = value.adSizes.split(',');
        }
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.VideoRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeVideoNameList = [];
        adSizesList.forEach((a) => {
          let adSize = audioSize.find((b) => b.key == a);
          if (adSize) {
            adSizeVideoNameList.push(adSize.value);
          }
        });

        value.adSizeVideoNameListDetail = adSizeVideoNameList; // use for component render
        value.adSizeVideoNameList = adSizeVideoNameList.toString(); // sorting
        value.fileUrl = value.fileUrl || '';
        value.isTag = true;
        return value;
      });
    }

    let audioUrl = [];
    if (item.audioUrl && item.audioUrl.length) {
      audioUrl = item.audioUrl.map((value) => {
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.VideoRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeVideoNameList = [];
        let adSize = audioSize.find((b) => b.key == value.adSize);
        if (adSize) {
          adSizeVideoNameList.push(adSize.value);
        }

        value.adSizeVideoNameListDetail = adSizeVideoNameList; // use for component render
        value.adSizeVideoNameList = adSizeVideoNameList.toString(); // sorting
        // value.tagUrl = <img src={value.fileUrl} />;
        value.tagUrl = value.fileUrl;
        value.fileUrl = value.fileUrl;
        value.tagId = value.videoId;
        value.isTag = false;
        return value;
      });
    }
    let audioWrapper = [];
    if (item.audioWrapper && item.audioWrapper.length) {
      audioWrapper = item.audioWrapper.map((value) => {
        return value;
      });
    }

    var serviceFiles = [];
    if (item.videoType === 1) {
      serviceFiles = item.fileType === 0 ? audio : audioUrl;
      item.clickUrl = item.fileType === 0 ? audio.length > 0 ? audio[0].clickUrl : '' : audioUrl.length > 0 ? audioUrl[0].clickUrl : '';
      item.landingPageUrl = item.fileType === 0 ? audio.length > 0 ? audio[0].landingPageUrl : '' : audioUrl.length > 0 ? audioUrl[0].landingPageUrl : '';
      // item.fileUrl = item.fileType == 1 ? audio.length > 0 ? audio[0].fileUrl : '' : audioUrl.length > 0 ? audioUrl[0].fileUrl : ''
      // item.sourceFile = item.fileType == 1 ? audio.length > 0 ? audio[0].fileUrl.replace(/^.*[\\\/]/, '') : '' : audioUrl.length > 0 ? audioUrl[0].fileUrl.replace(/^.*[\\\/]/, '') : ''
    }

    if (item.videoType === 2) {
      item.landingPageUrl = audioWrapper.length > 0 ? audioWrapper[0].landingPageUrl : '';
    }

    var creativeTrackers = item.creativeTrackers ? item.creativeTrackers.filter((item) => item.category === 1) : [];
    let type = item.videoType === 0 ? 'FILE HTML' : item.videoType === 1 ? 'FILE VAST' : 'VAST TAG';
    item.tagNativeData = [...audioUrl, ...audio];
    item.trackerEventsCount = creativeTrackers.length;
    item.serviceFilesCount = serviceFiles.length;
    item.type = type;
    return item;
  });
  return creativeAudioListData;
};

export const creativeNativeListAllReportData = (creativeNativeListData, nativeBannerSize, nativeVideoSize, recActiveList, creativeTypeList) => {
  creativeNativeListData.map((item) => {
    // logic recActiveName
    let Active = recActiveList.find((a) => a.id === item.recActive);
    if (Active) {
      item.recActiveName = Active.value;
    }

    // logic creativeType
    if (item.creativeType) {
      let creative = creativeTypeList.find(
        (a) => a.key === item.creativeType.toString()
      );
      if (creative) {
        item.creativeType = creative.value;
      } else {
        item.creativeType = '';
      }
    }

    let tagNativeDisplay = [];
    if (item.tagNativeDisplay && item.tagNativeDisplay.length) {
      tagNativeDisplay = item.tagNativeDisplay.map((value) => {
        let adSizesList = [];
        adSizesList = value.adSizes.split(',');
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.nativeRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeNativeNameList = [];
        adSizesList.forEach((a) => {
          let adSize = nativeBannerSize.find((b) => b.key == a);
          if (adSize) {
            adSizeNativeNameList.push(adSize.value);
          }
        });

        value.adSizeNativeNameListDetail = adSizeNativeNameList; // use for component render
        value.adSizeNativeNameList = adSizeNativeNameList.toString(); // sorting

        value.fileUrl = value.tagUrl;
        value.tagUrl = 'Tag';
        value.landingPageUrl = 'Tag';
        value.isTag = true;
        return value;
      });
    }

    let tagNativeVideo = [];
    if (item.tagNativeVideo && item.tagNativeVideo.length) {
      tagNativeVideo = item.tagNativeVideo.map((value) => {
        let adSizesList = [];
        adSizesList = value.adSizes.split(',');
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.nativeRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeNativeNameList = [];
        adSizesList.forEach((a) => {
          let adSize = nativeVideoSize.find((b) => b.key == a);
          if (adSize) {
            adSizeNativeNameList.push(adSize.value);
          }
        });

        value.adSizeNativeNameListDetail = adSizeNativeNameList; // use for component render
        value.adSizeNativeNameList = adSizeNativeNameList.toString(); // sorting
        value.fileUrl = value.tagUrl;
        value.tagUrl = 'Tag';
        value.landingPageUrl = 'Tag';
        value.isTag = true;
        return value;
      });
    }

    let nativeVideo = [];
    if (item.nativeVideo && item.nativeVideo.length) {
      nativeVideo = item.nativeVideo.map((value) => {
        let adSizesList = [];
        adSizesList = value.adSizes.split(',');
        //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.nativeRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeNativeNameList = [];
        adSizesList.forEach((a) => {
          let adSize = nativeVideoSize.find((b) => b.key == a);
          if (adSize) {
            adSizeNativeNameList.push(adSize.value);
          }
        });

        value.adSizeNativeNameListDetail = adSizeNativeNameList; // use for component render
        value.adSizeNativeNameList = adSizeNativeNameList.toString(); // sorting
        value.tagId = value.videoId;
        value.tagUrl = value.adUrl;
        value.fileUrl = value.adUrl;
        value.isVideo = true;
        value.isTag = false;

        return value;
      });
    }

    let nativeDisplay = [];
    if (item.nativeDisplay && item.nativeDisplay.length) {
      nativeDisplay = item.nativeDisplay.map((value) => {
        // //logic recActive
        let active = recActiveList.find((a) => a.id === value.recActive);
        if (active) {
          value.nativeRecActive = active.value;
        }

        // logic createRecDetails
        if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.createRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic modifyRecDetailsDateTime
        if (value.modifyRecDetails && value.modifyRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.modifyRecDetails.dateTime;
        } else if (value.createRecDetails && value.createRecDetails.dateTime) {
          value.modifyRecDetailsDateTime = value.createRecDetails.dateTime;
        }

        // logic adSize
        let adSizeNativeNameList = [];
        let adSize = nativeBannerSize.find((b) => b.key == value.adSizes);
        if (adSize) {
          adSizeNativeNameList.push(adSize.value);
        }

        value.adSizeNativeNameListDetail = adSizeNativeNameList; // use for component render
        value.adSizeNativeNameList = adSizeNativeNameList.toString(); // sorting
        value.tagId = value.displayId;
        value.tagUrl = <img src={value.adUrl} />;
        value.fileUrl = value.adUrl;
        value.isVideo = false;
        value.isTag = false;

        return value;
      });
    }
    item.tagNativeData = [
      ...tagNativeDisplay,
      ...tagNativeVideo,
      ...nativeDisplay,
      ...nativeVideo
    ];
    return item;
  });

  return creativeNativeListData;
};

export const tagDisplayData = (tagDisplayList, bannerSizeList, statusOptions) => {
  let data = [];
  if (tagDisplayList && bannerSizeList && bannerSizeList.length && tagDisplayList.length) {
    data = tagDisplayList.map((item) => {
      let adSizesArray = item.adSizes.split(',');
      let adSizesText = [];

      // logic adSizes
      adSizesArray.forEach((a) => {
        let data = bannerSizeList.find((adSize) => adSize.id === a);
        if (data) {
          adSizesText.push(data.text);
        }
      });
      item.adSizesName = adSizesText.toString();

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }
      return item;
    });
  }

  return data;
};

export const displayData = (displayList, bannerMimeTypeList, bannerSizeList, statusOptions) => {
  if (displayList && displayList.length) {
    displayList.map((item) => {
      // logic adFormatName
      let bannerMime = bannerMimeTypeList.find((a) => a.key == item.adFormat);

      if (bannerMime) {
        item.adFormatName = bannerMime.value;
      } else {
        item.adFormatName = '';
      }

      // logic adSizeName
      let bannerSize = bannerSizeList.find((a) => a.key == item.adSize);
      if (bannerSize) {
        item.adSizeName = bannerSize.value;
      } else {
        item.adSizeName = '';
      }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return displayList;
};

export const tagVideoData = (tagVideoList, videoMimeTypeList, videoSizeList, statusOptions) => {
  let data = [];
  if (tagVideoList && videoSizeList && videoSizeList.length && tagVideoList.length) {
    data = tagVideoList.map((item) => {
      // let adSizesArray = item.adSizes ? item.adSizes.split(',') : []
      // let adSizesText = [];

      // // logic adSizes
      // adSizesArray.forEach((a) => {
      //   let data = videoSizeList.find((adSize) => adSize.key === a);
      //   if (data) { adSizesText.push(data.value); }
      // });
      // item.adSizesName = adSizesText.toString();

      let data = videoSizeList.find((adSize) => adSize.key == item.adSizes);
      item.adSizesName = data.value;

      // logic adFormatName
      // let videoMime = videoMimeTypeList.find((a) => (a.key == item.adFormat));
      let videoMime = videoMimeTypeList.find((a) => a.key == item.mimetypes);
      let adFormat = videoMimeTypeList.find((a) => a.key == item.adFormat);

      if (videoMime) {
        item.mimetypes = videoMime.value;
        item.adFormatName = videoMime.value;
      } else {
        item.mimetypes = '';
      }

      // if (item.tagUrl && item.tagUrl == '') {
      //   if (item.fileUrl != '') {
      //     item.tagUrl = item.fileUrl
      //   }
      // }

      if (item.fileUrl && item.fileUrl != '') {
        item.tagUrl = item.fileUrl;
      }

      if (adFormat) {
        item.adFormat = adFormat.key;
        item.adFormatName = adFormat.value;
      } else {
        item.adFormat = '';
      }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return data;
};

export const videoData = (videoList, videoMimeTypeList, videoSizeList, statusOptions) => {
  if (videoList && videoList.length) {
    videoList.map((item) => {
      // logic adFormatName
      let videoMime = videoMimeTypeList.find((a) => a.key == item.adFormat);

      if (videoMime) {
        item.adFormatName = videoMime.value;
        item.mimeTypes = videoMime.value;
      } else {
        item.adFormatName = '';
      }

      // logic adSizeName
      let videoSize = videoSizeList.find((a) => a.key == item.adSize);
      if (videoSize) {
        item.adSizeName = videoSize.value;
      } else {
        item.adSizeName = '';
      }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return videoList;
};

export const typeUrlAudioData = (tagVideoList, videoMimeTypeList, videoSizeList, statusOptions) => {
  let data = [];
  if (tagVideoList && videoSizeList && videoSizeList.length && tagVideoList.length) {
    data = tagVideoList.map((item) => {
      // logic adFormatName
      // let videoMime = videoMimeTypeList.find((a) => (a.key == item.adFormat));
      let videoMime = videoMimeTypeList.find((a) => a.key == item.mimetypes);
      // let adFormat = videoMimeTypeList.find((a) => (a.key == item.adFormat));

      if (videoMime) {
        item.mimetypes = videoMime.value;
        item.adFormatName = videoMime.value;
      } else {
        item.mimetypes = '';
      }

      if (item.fileUrl && item.fileUrl != '') {
        item.tagUrl = item.fileUrl;
      }

      // if (adFormat) {
      //   item.adFormat = adFormat.key;
      //   item.adFormatName = adFormat.value
      // } else {
      //   item.adFormat = '';
      // }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return data;
};

export const typeFileAudioData = (videoList, videoMimeTypeList, videoSizeList, statusOptions) => {
  if (videoList && videoList.length) {
    videoList.map((item) => {
      // logic adFormatName
      let videoMime = videoMimeTypeList.find((a) => a.key == item.adFormat);

      if (videoMime) {
        item.adFormatName = videoMime.value;
        item.mimeTypes = videoMime.value;
      } else {
        item.adFormatName = '';
      }

      // logic adSizeName
      let videoSize = videoSizeList.find((a) => a.key == item.adSize);
      if (videoSize) {
        item.adSizeName = videoSize.value;
      } else {
        item.adSizeName = '';
      }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return videoList;
};
export const tagNativeDisplayData = (tagNativeDisplayList, nativeBannerSizeList, statusOptions) => {
  let data = [];
  if (tagNativeDisplayList && nativeBannerSizeList && nativeBannerSizeList.length && tagNativeDisplayList.length) {
    data = tagNativeDisplayList.map((item) => {
      let adSizesArray = item.adSizes.split(',');
      let adSizesText = [];

      // logic adSizes
      adSizesArray.forEach((a) => {
        let data = nativeBannerSizeList.find((adSize) => adSize.id === a);
        if (data) {
          adSizesText.push(data.text);
        }
      });
      item.adSizesName = adSizesText.toString();

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }

  return data;
};

export const nativeDisplayData = (displayList, nativeBannerMimeTypeSize, nativeBannerSizeList, statusOptions) => {
  if (displayList && displayList.length) {
    displayList.map((item) => {
      // logic adFormatName
      let nativeBannerMime = nativeBannerMimeTypeSize.find(
        (a) => a.key == item.adFormat
      );

      if (nativeBannerMime) {
        item.adFormatName = nativeBannerMime.value;
      } else {
        item.adFormatName = '';
      }

      let adSizesArray = item.adSizes.split(',');
      let adSizesText = [];

      // logic adSizes
      adSizesArray.forEach((a) => {
        let data = nativeBannerSizeList.find((adSize) => adSize.id === a);
        if (data) {
          adSizesText.push(data.text);
        }
      });
      item.adSizesName = adSizesText.toString();

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return displayList;
};

export const tagNativeVideoData = (tagNativeVideoList, nativeVideoMimeTypeList, nativeVideoSizeList, statusOptions) => {
  let data = [];
  if (tagNativeVideoList && nativeVideoSizeList && nativeVideoSizeList.length && tagNativeVideoList.length) {
    data = tagNativeVideoList.map((item) => {
      let adSizesArray = item.adSizes.split(',');
      let adSizesText = [];

      // logic adSizes
      adSizesArray.forEach((a) => {
        let data = nativeVideoSizeList.find((adSize) => adSize.id === a);
        if (data) {
          adSizesText.push(data.text);
        }
      });
      item.adSizesName = adSizesText.toString();

      // logic adFormatName
      let videoMime = nativeVideoMimeTypeList.find(
        (a) => a.key == item.adFormat
      );

      if (videoMime) {
        item.mimetype = videoMime.value;
      } else {
        item.mimetype = '';
      }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }

  return data;
};

export const nativeVideoData = (nativeVideoList, nativeVideoMimeTypeList, nativeVideoSizeList, statusOptions) => {
  if (nativeVideoList && nativeVideoList.length) {
    nativeVideoList.map((item) => {
      let adSizesArray = item.adSizes.split(',');
      let adSizesText = [];

      // logic adSizes

      adSizesArray.forEach((a) => {
        let data = nativeVideoSizeList.find((adSize) => adSize.id === a);
        if (data) {
          adSizesText.push(data.text);
        }
      });
      item.adSizesName = adSizesText.toString();

      // logic adFormatName
      let videoMime = nativeVideoMimeTypeList.find(
        (a) => a.key == item.adFormat
      );

      if (videoMime) {
        item.adFormatName = videoMime.value;
        item.mimetype = videoMime.value;
      } else {
        item.adFormatName = '';
      }

      // // logic adSizeName
      // let videoSize = nativeVideoSizeList.find((a) => (a.key == item.adSize));
      // if (videoSize) {
      //   item.adSizeName = videoSize.value;
      // } else {
      //   item.adSizeName = '';
      // }

      // logic Status
      let active = statusOptions.find((a) => a.id == item.recActive);
      if (active) {
        item.statusName = active.value;
      }

      // logic modifyRecDetailsDateTime
      if (item.modifyRecDetails && item.modifyRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.modifyRecDetails.dateTime;
      } else if (item.createRecDetails && item.createRecDetails.dateTime) {
        item.modifyRecDetailsDateTime = item.createRecDetails.dateTime;
      }

      return item;
    });
  }
  return nativeVideoList;
};

export const privateMarketPlaceDate = (responseList, adUnitList, addUnitGroupList, countryList, getStateAllList = [], getCityAllList = [], currencyList, deviceType, auctionList) => {
  let data = [];
  data = responseList.map((item) => {
    // logic currencyList
    let currencyName = currencyList.find(
      (a) => a.key === item.currency.toString()
    );
    if (currencyName) {
      item.currencyName = currencyName.value;
    } else {
      item.currencyName = '';
    }

    // logic auctionList
    let auctionName = auctionList.find(
      (a) => a.key === item.pmpAuctionType.toString()
    );
    if (auctionName) {
      item.auctionName = auctionName.value;
    } else {
      item.auctionName = '';
      item.countrytName = '';
    }
    //     item.countryDetail = [];
    //     // logic countryList
    //     if (item.pmpGeo && item.pmpGeo.length) {
    //       if (item.pmpGeo.length === countryList.length) {
    //         item.countryDetail = ["All"]; // use for component render
    //         item.countrytName = "All"; // sorting

    //       } else {
    //         let countryNames = [];

    //         // item.pmpGeo.forEach(b => {
    //         // let country = countryList.find((a) => (a.id === (b.geo.geoId).toString()));
    //         // if (country) {
    //         //   countryNames.push(country.countryName);
    //         // }
    //         // })

    //         (item.pmpGeo || []).forEach((a) => {
    //           if (a.geo.geoType == 1) {
    //             let matchCountry = countryList.find((b) => b.id == a.geo.geoId);
    //             if (matchCountry) { countryNames.push(matchCountry.countryName) }
    //           }

    //           if (a.geo.geoType == 2) {
    //             let matchState = getStateAllList.find((b) => b.id == a.geo.geoId)
    //             if (matchState) { countryNames.push(matchState.stateName) }
    //           }

    //           if (a.geo.geoType == 3) {
    //             let matchCity = getCityAllList.find((b) => b.id == a.geo.geoId)
    //             if (matchCity) { countryNames.push(matchCity.cityName) }
    //           }
    //         });

    //         item.countryDetail = countryNames.length  ?  countryNames:['All']; // use for component render
    //         item.countrytName = (countryNames.length  ?  countryNames :['All']).toString(); // sorting
    //         item.countrytName = (countryNames.length  ?  countryNames :['All']).toString(); // sorting
    //         item.countrytName = (countryNames.length  ?  countryNames :['All']).toString(); // sorting
    //         item.countrytName = (countryNames.length  ?  countryNames :['All']).toString(); // sorting
    //         item.countrytName = (countryNames.length  ?  countryNames :['All']).toString(); // sorting
    //         // item.countryDetail = countryNames.length === countryList.length ? ['All'] : countryNames; // use for component render

    item.countryDetail = [];
    let countryNames = [];
    // logic countryList
    if (item.pmpGeo && item.pmpGeo.length) {
      (item.pmpGeo || []).forEach((a) => {
        if (a.geo.geoType == 1) {
          countryNames.push(a.geo.geoValue);
          // let matchCountry = countryList.find((b) => b.id == a.geo.geoId);
          // if (matchCountry) { countryNames.push(matchCountry.countryName) }
        }

        if (a.geo.geoType == 2) {
          countryNames.push(a.geo.geoValue);
          // let matchState = getStateAllList.find((b) => b.id == a.geo.geoId)
          // if (matchState) { countryNames.push(matchState.stateName) }
        }

        if (a.geo.geoType == 3) {
          countryNames.push(a.geo.geoValue);
          // let matchCity = getCityAllList.find((b) => b.id == a.geo.geoId)
          // if (matchCity) { countryNames.push(matchCity.cityName) }
        }

        if (a.geo.geoType == 4) {
          countryNames.push(a.geo.geoValue);
        }
      });
    }
    item.countryDetail = countryNames.length ? countryNames : ['All']; // use for component render
    item.countrytName = (
      countryNames.length ? countryNames : ['All']
    ).toString(); // sorting

    // pmp target logic
    let pmpTargetNames = [];
    if (item.pmpTarget && item.pmpTarget.length) {
      item.pmpTarget.forEach(({ targetId }) => {
        let deviceTypeMatch = deviceType.find((b) => b.key == targetId);
        if (deviceTypeMatch) {
          pmpTargetNames.push(deviceTypeMatch.value);
        }
      });
    }

    item.pmpTargetDetail = pmpTargetNames; // use for component render
    item.pmpTargetName = pmpTargetNames.toString(); // sorting

    // logic pmpAdgroups and splic (adGroups, adUnits)
    let adGroups = [];
    let adUnits = [];
    if (item.pmpAdgroups && item.pmpAdgroups.length) {
      item.pmpAdgroups.forEach((item) => {
        if (item.adtype) {
          adGroups.push(item.adUnitGroupId);
        } else {
          adUnits.push(item.adUnitGroupId);
        }
      });
    }

    // logic adGroups
    let adGroupNameList = [];
    if (adGroups && adGroups.length) {
      adGroups.forEach((a) => {
        let addUnitGroupMatch = addUnitGroupList.find((b) => b.adGroupId == a);
        if (addUnitGroupMatch) {
          adGroupNameList.push(addUnitGroupMatch.adGroupName);
        }
      });
    }

    item.adGroupNameDetail = adGroupNameList; // use for component render
    item.adGroupName = adGroupNameList.toString(); // sorting

    // logic adUnitList
    let adUnitNameList = [];
    if (adUnits && adUnits.length) {
      adUnits.forEach((a) => {
        let adUnitIdMatch = adUnitList.find((b) => b.adUnitId == a);
        if (adUnitIdMatch) {
          adUnitNameList.push(adUnitIdMatch.adUnitName);
        }
      });
    }

    item.adUnitNameDetail = adUnitNameList; // use for component render
    item.adUnitName = adUnitNameList.toString(); // sorting

    if (item.pmpFlight && item.pmpFlight.length) {
      const {
        pmpFlight: [{ startDate, endDate }]
      } = item;
      item.startDate = startDate;
      item.endDate = endDate;
    }

    return item;
  });

  return data;
};

export const openRTBMediationData = (formOpenRTBList, demandpartnerSeatList, deviceTypeList, creativeType) => {
  let bannerMimeList = creativeType.nativeAdTypeList.concat(
    creativeType.creativeTypeList
  );

  formOpenRTBList.map((item, index) => {
    item.rtbID = index;

    // logic demandPartnerName
    let demandpartner = demandpartnerSeatList.find(
      (a) => a.seatId == item.mfDemandPartnerId
    );
    if (demandpartner) {
      item.demandPartnerName = demandpartner.demandPartnerName;
    }

    // logic split geo and configurationIdList
    let geoNameList = [];
    let deviceNameList = [];
    let adSizeNameList = [];
    let adFormatNameList = [];

    let configurationIdList = [];
    item.mediationFlowDetails.forEach((a) => {
      if (a.catVariableType === 1) {
        geoNameList.push(a.catValue);
        // let country = countryList.find((b) => b.id == a.catVariable);
        // if (country) {
        //   geoNameList.push(country.countryName);
        // }
      } else if (a.catVariableType === 0) {
        let device = deviceTypeList.find((b) => b.id == a.catVariable);
        if (device) {
          deviceNameList.push(device.text);
        }

        //  logic bannerMime
        let bannerMime = bannerMimeList.find((b) => b.key == a.catVariable);
        if (bannerMime) {
          adFormatNameList.push(bannerMime.value);
        }

        //  logic bannerSize
        let bannerSize = creativeType.bannerSize.find(
          (b) => b.key == a.catVariable
        );
        if (bannerSize) {
          adSizeNameList.push(`${bannerSize.value} (Banner)`);
        }

        //  logic bannerSize
        let videoSize = creativeType.videoSize.find(
          (b) => b.key == a.catVariable
        );
        if (videoSize) {
          adSizeNameList.push(`${videoSize.value} (Video)`);
        }
        let audioSize = creativeType.companion.find(
          (b) => b.key == a.catVariable
        );
        if (audioSize) {
          adSizeNameList.push(`${audioSize.value} (Audio)`);
        }

        //  logic nativeBannerSize
        let nativeBannerSize = creativeType.nativeBannerSize.find(
          (b) => b.key == a.catVariable
        );
        if (nativeBannerSize) {
          adSizeNameList.push(`${nativeBannerSize.value} (Native Banner)`);
        }

        //  logic nativeVideoSize
        let nativeVideoSize = creativeType.nativeVideoSize.find(
          (b) => b.key == a.catVariable
        );
        if (nativeVideoSize) {
          adSizeNameList.push(`${nativeVideoSize.value} (Native Video)`);
        }

        configurationIdList.push(a.catVariable);
      } else if (a.catVariableType === 2) {
        // let state = getStateAllList.find((b) => b.id == a.catVariable);
        // if (state) {
        //   geoNameList.push(state.stateName);
        // }
        geoNameList.push(a.catValue);
      } else if (a.catVariableType === 3) {
        // let city = getCityAllList.find((c) => c.id == a.catVariable);
        // if (city) {
        //   geoNameList.push(city.cityName);
        // }
        geoNameList.push(a.catValue);
      } else if (a.catVariableType === 4) {
        geoNameList.push(a.catValue);
      }
    });

    item.geoNameListDetail = geoNameList; // use for component render
    item.geoNameList = geoNameList.toString(); // sorting

    item.deviceNameListDetail = deviceNameList; // use for component render
    item.deviceNameList = deviceNameList.toString(); // sorting

    item.adFormatNameListDetail = adFormatNameList; // use for component render
    item.adFormatNameList = adFormatNameList.toString(); // sorting

    item.adSizeNameListDetail = adSizeNameList; // use for component render
    item.adSizeNameList = adSizeNameList.toString(); // sorting

    return item;
  });

  return formOpenRTBList;
};

export const mediationData = (mediationList, mediationTypeData, mediationTemplateTypeList, auctionTypeList) => {
  mediationList.map((item) => {
    // logic flowList
    let data = [];
    if (item.mediationFlow) {
      item.mediationFlow.forEach((a) => {
        data.push(a.mfMediationType);
      });
    }

    let flowList = [];
    (_.uniq(data) || []).forEach((a) => {
      let mediationTypeName = mediationTypeData.find(
        (b) => parseInt(b.key) === a
      );
      if (mediationTypeName) {
        flowList.push(mediationTypeName.value);
      }
    });

    item.flowNameListDetail = flowList; // use for component render
    item.flowNameList = flowList.toString(); // sorting

    // logic mtType
    let mtType = mediationTemplateTypeList.find((a) => a.key == item.mtType);
    if (mtType) {
      item.mtTypeName = mtType.value;
    }
    // logic mtAuctionType
    let mtAuctionType = auctionTypeList.find((a) => a.id == item.mtAuctionType);
    if (mtAuctionType) {
      item.mtAuctionTypeName = mtAuctionType.value;
    }
    item.status = item.mtStatus ? 'Active' : 'In-active';
    return item;
  });

  return mediationList;
};

export const mediationAdGroupData = (mediationAdGroupList, mediationTemplateTypeList) => {
  mediationAdGroupList.map((item) => {
    let mtTypeName = mediationTemplateTypeList.find(
      (a) => parseInt(a.key) === item.mtType
    );
    if (mtTypeName) {
      item.mtTypeName = mtTypeName.value;
    }

    item.Date = `${item.mtStartDate}-${item.mtEndDate}`;

    if (item.adGroupDetails && item.adGroupDetails.length) {
      item.status = item.adGroupDetails[0].isActiveFlag
        ? 'Active'
        : 'In-Active';
    }

    item.mtName = item.mtName;

    let adUnitGroupName = [];
    if (item.adGroupDetails && item.adGroupDetails.length) {
      item.adGroupDetails.forEach((a) => {
        adUnitGroupName.push(a.adUnitGroupName);
        item.type = a.magAdType ? 'Grouped' : 'Individual Ad';
      });
    }
    item.adUnitGroupNameListDetail = adUnitGroupName; // use for component render
    item.adUnitGroupNameList = adUnitGroupName.toString(); // sorting
    return item;
  });
  return mediationAdGroupList;
};

export const getDataCapture = ({ dataCaptureAllList = [], ioAdvertisersReport = [], eventTypeList = [], pixelMicorsList = [], pixelConditionList = [], pixelTypeList = [] }) => {
  let data = [];
  let dataCaptureAll = dataCaptureAllList.map((item) => {
    (item.segments || []).map((a) => (a.pixelType = item.pixelType));
    return item;
  });

  data = groupBy(dataCaptureAll, 'advertiserId');

  let captureList = [];
  Object.keys(data).forEach((key) => {
    let dataCaptureObj = {};

    if (data[key] && data[key].length) {
      const { advertiserId = '', pixelId = '', advertiserName = '', createRecDetails = {}, modifyRecDetails = {}, pixelUrl = '' } = data[key][0] ? data[key][0] : {};
      let matchIoA = ioAdvertisersReport.find((a) => a.key == advertiserId);
      if (matchIoA) {
        dataCaptureObj.advertiserName = matchIoA.value;
      }

      dataCaptureObj.pixelId = pixelId;
      dataCaptureObj.advertiserName = advertiserName;
      // dataCaptureObj.pixelUrl = pixelUrl
      dataCaptureObj.advertiserId = advertiserId;

      // if (createRecDetails && createRecDetails.dateTime) {
      //   dataCaptureObj.createdDate = moment.min(createRecDetails.dateTime)
      // } else {
      //   dataCaptureObj.createdDate = '';
      // }

      // if (modifyRecDetails && modifyRecDetails.dateTime) {
      //   dataCaptureObj.lastUpdateDate = moment.max(modifyRecDetails.dateTime)
      // } else {
      //   dataCaptureObj.lastUpdateDate = '';
      // }
      let createdD = [];
      let modifyD = [];
      data[key].forEach((captureItem) => {
        createdD.push(new Date(captureItem.createRecDetails.dateTime));
        if (
          captureItem.modifyRecDetails &&
          captureItem.modifyRecDetails.dateTime
        ) {
          modifyD.push(new Date(captureItem.modifyRecDetails.dateTime));
        } else {
          modifyD.push(new Date(captureItem.createRecDetails.dateTime));
        }
      });
      let maxDateC = new Date(Math.max.apply(null, createdD));
      let maxDateM = new Date(Math.max.apply(null, modifyD));

      dataCaptureObj.createdDate = maxDateC;
      dataCaptureObj.lastUpdateDate = maxDateM;

      let segmentsData = [];
      data[key].forEach((captureItem) => {
        if (captureItem.segments && captureItem.segments.length) {
          // logic postback
          if (captureItem.pixelType == 1) {
            captureItem.segments.forEach((item) => {
              item.SegmentObj = item;
              let eventSegment = item.eventSegment && item.eventSegment[0] ? item.eventSegment[0] : '';
              item.eventTypeName = eventSegment.eventTypeName;
              item.tagName = eventSegment.name;
              item.pixelId = eventSegment.pixelId;
              item.pixelUrl = captureItem.pixelUrl;
              item.creationDate = captureItem.createRecDetails && captureItem.createRecDetails.dateTime ? captureItem.createRecDetails.dateTime : '';
              item.lastUpdate = captureItem.modifyRecDetails && captureItem.modifyRecDetails.dateTime ? captureItem.modifyRecDetails.dateTime : captureItem.createRecDetails.dateTime;
              item.tagNameList = [];

              // logic pixelTypeName
              let matchPixelType = pixelTypeList.find(
                (a) => a.key == item.pixelType
              );
              if (matchPixelType) {
                item.pixelTypeName = matchPixelType.value;
              }

              if (item.rule && item.rule.length) {
                item.rule.forEach((a) => {
                  let matchPixelMicors = (pixelMicorsList || []).find((b) => b.key == a.attribute);
                  if (matchPixelMicors) {
                    a.attributeName = matchPixelMicors.value;
                  }

                  let matchPixelCondition = (pixelConditionList || []).find((b) => b.key == a.condition);
                  if (matchPixelCondition) {
                    a.conditionName = matchPixelCondition.value;
                  }
                  item.tagNameList.push(a);
                });
              }

              segmentsData.push(item);
            });

            // logic jsimg/tag
          } else if (captureItem.pixelType == 2) {
            let jsImgSegments = {};
            let data = captureItem.segments[0] ? captureItem.segments[0] : {};
            let eventTagObj = data.eventSegment[0] ? data.eventSegment[0] : '';

            jsImgSegments.tagName = eventTagObj.name;
            jsImgSegments.eventTypeName = eventTagObj.eventTypeName;
            jsImgSegments.pixelId = eventTagObj.pixelId;
            jsImgSegments.SegmentObj = data;
            jsImgSegments.segmentId = data.segmentId;
            jsImgSegments.pixelUrl = captureItem.pixelUrl;
            jsImgSegments.pixelIframeTag = eventTagObj.pixelIframeTag;
            jsImgSegments.pixelImgTag = eventTagObj.pixelImgTag;

            jsImgSegments.pixelType = captureItem.pixelType;
            jsImgSegments.creationDate = captureItem.createRecDetails && captureItem.createRecDetails.dateTime ? captureItem.createRecDetails.dateTime : '';
            jsImgSegments.lastUpdate = captureItem.modifyRecDetails && captureItem.modifyRecDetails.dateTime ? captureItem.modifyRecDetails.dateTime : captureItem.createRecDetails.dateTime;

            // logic pixelTypeName
            let matchPixelType = pixelTypeList.find((a) => a.key == data.pixelType);
            if (matchPixelType) {
              jsImgSegments.pixelTypeName = matchPixelType.value;
            }

            jsImgSegments.tagNameList = [];
            captureItem.segments.forEach((item, index) => {
              let eventObj = item.eventSegment[0] ? item.eventSegment[0] : '';
              if (index) {
                eventObj.attributeName = eventObj.name;
                eventObj.conditionName = eventObj.eventTypeName;
                eventObj.value = eventObj.pixelEventUrl;
                eventObj.viewCode = true;
                eventObj.triggerEvent = `triggerEvent("${eventObj.name}");`;
                eventObj.pixelIframeTag = eventObj.pixelIframeTag;
                eventObj.pixelImgTag = eventObj.pixelImgTag;

                jsImgSegments.tagNameList.push(eventObj);
              }
            });
            segmentsData.push(jsImgSegments);
          }
        }
      });
      dataCaptureObj.segments = segmentsData;
      captureList.push(dataCaptureObj);
    }
  });
  return captureList;
};

// ---* array sort *---
export const sortArray = (dataList, key) =>
  _.sortBy(dataList, [(o) => (o.value || o[key]).toLowerCase()]);

export const removeSpaces = (key) => {
  let value = '';
  if (key) {
    value = key.trim();
  }
  return value;
};

export const getBreadCrumbLabelsLeft = (pagePath) => {
  switch (pagePath) {
    case 'dashboard':
      return 'Dashboard';

    case 'admin':
      return 'Admin';

    case 'tenant':
      return 'Tenant';

    case 'add-tenant':
      return 'Add';

    case 'edit-tenant':
      return 'Edit';

    case 'view-tenant':
      return 'View';

    case 'account':
      return 'Profile';

    case 'add-account':
      return 'Add';

    case 'edit-account':
      return 'Edit';

    case 'view-account':
      return 'View';


    case 'advertiser-list':
      return 'Advertiser';

    case 'add-advertiser':
      return 'Add';

    case 'edit-edit-advertise':
      return 'Edit';

    case 'user':
      return 'User';

    case 'add-user':
      return 'Add';

    case 'edit-user':
      return 'Edit';

    case 'campaign':
      return 'Campaign';

    case 'add-campaign':
      return 'Add';

    // RO functionality disabled
    // case 'map-mandate':
    //   return 'Map Mandate To Mandate Group';

    case 'edit-campaign':
      return 'Edit';

    case 'mediaplan':
      return 'Media Plan';

    case 'add-media':
      return 'Add';


    case 'adminMargin':
      return 'Admin Margin';

    case 'add-admin-margin':
      return 'Add';

    case 'edit-admin-margin':
      return 'Edit';

    case 'margin':
      return 'Margin';

    case 'add-margin':
      return 'Add';

    case 'edit-margin':
      return 'Edit';


    case 'ro':
      return 'Goals';

    case 'goals-list':
      return 'Goals';

    case 'add-ro':
      return 'Add';

    case 'view-ro':
      return 'View';

    case 'edit-ro':
      return 'Edit';


    case 'add-goal':
      return 'Add';

    case 'view-goal':
      return 'View';

    case 'edit-goal':
      return 'Edit';


    case 'unmapped-campaign':
      return 'Unmapped Campaign';

    case 'create-ro':
      return 'Create';


    case 'map-ro':
      return 'Map';


    case 'create-goal':
      return 'Create';


    case 'map-goal':
      return 'Map';


    case 'optimizer':
      return 'Optimizer';

    case 'recommendations':
      return 'Recommendations';

    case 'history':
      return 'History';

    case 'generativeai':
      return 'Generative AI';
    case 'blacklisting-whitelisting':
      return 'Blacklisting-Whitelisting';
    case 'budgetoptimisation':
      return 'Budget Optimisation';
    case 'bidcontrol':
      return 'Bid Control';
    // case 'history':
    //   return 'History';


    case 'audience':
      return 'Audience'

    case 'custom-audience':
      return 'Custom Audience'

    case 'audience-hierarchy':
      return 'Audience Hierarchy'

    case 'hierarchy-manager':
      return 'Hierarchy Manager'

    case 'taxonomy-manager':
      return 'Taxonomy Manager'

    case 'add-taxonomy-manager':
      return 'Add';

    case 'edit-taxonomy-manager':
      return 'edit'



    case 'data-capture':
      return 'Data Capture'

    case 'add-data-capture':
      return 'Add';

    case 'edit-data-capture':
      return 'edit'



    case 'data-config':
      return 'Data Config'

    case 'dsp-platform':
      return 'DSP Platform';

    case 'add':
      return 'Add'


    case 'edit':
      return 'Edit'




    case 'variables':
      return 'Variable'


    case 'add-variables':
      return 'Add'

    case 'edit-variables':
      return 'Edit';




    case 'payment':
      return 'Payment'


    case 'add-payment':
      return 'Add'

    case 'billing-history':
      return 'Transaction history';

    case 'invoice':
      return 'Invoice';

    case 'subscription':
      return 'Subscription';


    case 'fee-settings':
      return 'Fee Settings';

    case 'add-fee-settings':
      return 'Add';

    case 'edit-fee-settings':
      return 'Edit';

    case 'view-fee-settings':
      return 'View';

    case 'update-fee-settings':
      return 'Bulk Update';

    case 'subscriptionPlanMgr':
      return 'Subscription Plan Mgr';

    case 'add-subscription-plan':
      return 'Add';

    case 'edit-subscription-plan':
      return 'Edit';


    case 'delivery-plan':
      return 'Delivery Plan';

    case 'add-delivery-plan':
      return 'Add Delivery Plan';

    case 'edit-delivery-plan':
      return 'Edit Delivery Plan';

    case 'view-delivery-plan':
      return 'View Delivery Plan';

    case "audience-market-place":
      return "Audience Market Place";

    case "view-briefs-draft":
      return "View";

  }






};

export const getBreadCrumbLabels = (pagePath) => {
  switch (pagePath) {
    case 'dashboard':
      return 'Dashboard';

    case 'admin':
      return 'Admin';

    case 'tenant':
      return 'Tenant';

    case 'add-tenant':
      return 'Add Tenant';

    case 'edit-tenant':
      return 'Edit';

    case 'view-tenant':
      return 'View';

    case 'account':
      return 'Profile';

    case 'add-account':
      return 'Add';

    case 'edit-account':
      return 'Edit';

    case 'view-account':
      return 'View';


    case 'advertiser-list':
      return 'Advertiser';

    case 'add-advertiser':
      return 'Add Advertiser';

    case 'edit-edit-advertise':
      return 'Edit';

    case 'user':
      return 'User';

    case 'add-user':
      return 'Add User';

    case 'edit-user':
      return 'Edit';

    case 'campaign':
      return 'Campaign';

    case 'add-campaign':
      return 'Add Campaign';

    // RO functionality disabled
    // case 'map-mandate':
    //   return 'Map Mandate To Mandate Group';

    case 'edit-campaign':
      return 'Edit Campaign';

    case 'mediaplan':
      return 'Media Plan';

    case 'add-media':
      return 'Add Media Plan';


    case 'adminMargin':
      return 'Admin Margin';

    case 'add-admin-margin':
      return 'Add Admin Margin';

    case 'edit-admin-margin':
      return 'Edit Admin Margin';

    case 'margin':
      return 'Margin';

    case 'add-margin':
      return 'Add Margin';

    case 'edit-margin':
      return 'Edit Margin';


    case 'ro':
      return 'Ro';

    case 'goals-list':
      return 'Goals';

    case 'add-ro':
      return 'Add Goals';

    case 'add-goal':
      return 'Add Goal';

    case 'view-ro':
      return 'View Goals';

    case 'view-goal':
      return 'View Goal';

    case 'edit-ro':
      return 'Edit Goal';

    case 'edit-goal':
      return 'Edit Goal';

    case 'unmapped-campaign':
      return 'Unmapped Campaign';

    case 'create-ro':
      return 'Create Goals';

    case 'create-goal':
      return 'Create Goal';


    case 'map-ro':
      return 'Map Goals';

    case 'map-goal':
      return 'Map Goal';






    case 'optimizer':
      return 'Optimizer';

    case 'recommendations':
      return 'Recommendations';

    case 'history':
      return 'History';

    case 'generativeai':
      return 'Generative AI';
    case 'blacklisting-whitelisting':
      return 'Blacklisting-Whitelisting';
    case 'budgetoptimisation':
      return 'Budget Optimisation';
    case 'bidcontrol':
      return 'Bid Control';
    // case 'history':
    //   return 'History';


    case 'audience':
      return 'Audience'
    case 'custom-audience':
      return 'Custom Audience'

    case 'audience-hierarchy':
      return 'Audience Hierarchy'

    case 'hierarchy-manager':
      return 'Hierarchy Manager'

    case 'taxonomy-manager':
      return 'Taxonomy Manager'

    case 'add-taxonomy-manager':
      return 'Add';

    case 'edit-taxonomy-manager':
      return 'edit'



    case 'data-capture':
      return 'Data Capture'

    case 'add-data-capture':
      return 'Add';

    case 'edit-data-capture':
      return 'edit'


    case 'data-config':
      return 'Data Config'

    case 'dsp-platform':
      return 'DSP Platform';

    case 'add':
      return 'Add platform'


    case 'edit':
      return 'Edit platform'




    case 'variables':
      return 'Variable'


    case 'add-variables':
      return 'Add Variable'

    case 'edit-variables':
      return 'Edit Variable';





    case 'payment':
      return 'Payment'


    case 'add-payment':
      return 'Add'

    case 'billing-history':
      return 'Transaction history';

    case 'invoice':
      return 'Invoice';

    case 'subscription':
      return 'Subscription';


    case 'fee-settings':
      return 'Fee Settings';

    case 'add-fee-settings':
      return 'Add';

    case 'edit-fee-settings':
      return 'Edit';

    case 'view-fee-settings':
      return 'View';

    case 'update-fee-settings':
      return 'Bulk Update';

    case 'subscriptionPlanMgr':
      return 'Subscription Plan Mgr';

    case 'add-subscription-plan':
      return 'Add';

    case 'edit-subscription-plan':
      return 'Edit';


    case 'delivery-plan':
      return 'Delivery Plan';

    case 'add-delivery-plan':
      return 'Add Delivery Plan';

    case 'edit-delivery-plan':
      return 'Edit Delivery Plan';

    case 'view-delivery-plan':
      return 'View Delivery Plan';

    case "audience-market-place":
      return "Audience Market Place";

    case "view-briefs-draft":
      return "View";

  }
};

export const renderColumnHeading = ({ type }) => {
  let columnHeading = '';
  switch (type) {
    case 'adunit':
      columnHeading = (
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Ad Unit</th>
          <th scope="col">Ad Format</th>
          <th scope="col">
            <center>Actions</center>
          </th>
        </tr>
      );
      return columnHeading;
    case 'adunit-group':
      columnHeading = (
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Ad Unit Group</th>
          <th scope="col">Ad Unit</th>
          <th scope="col">
            <center>Actions</center>
          </th>
        </tr>
      );
      return columnHeading;
    case 'mediation':
      columnHeading = (
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Ad Group</th>
          <th scope="col">Ad Unit Group</th>
          <th scope="col">
            <center>Actions</center>
          </th>
        </tr>
      );
      return columnHeading;
  }
};

export const renderTableData = ({ type, data }) => {
  let tableData = '';
  switch (type) {
    case 'adunit':
      tableData =
        data &&
        data.map((list, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{list.adUnitName}</td>
            <td>Display</td>
            <td className="text-center">
              <a className="btn btn-outline-primary">
                &nbsp;
                <i className="mdi mdi-pencil" />
              </a>
              <a
                className="btn btn-outline-primary"
                data-code=""
                data-unitname="Unit 1"
              >
                <i className="mdi mdi-code-tags"></i>
                <span>Generate Code</span>
              </a>
            </td>
          </tr>
        ));
      return tableData;
    case 'adunit-group':
      tableData =
        data &&
        data.map((list, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{list.adUnitName}</td>
            <td>Display</td>
            <td className="text-center">
              <a className="btn btn-outline-primary">
                &nbsp;
                <i className="mdi mdi-pencil" />
              </a>
              <a
                className="btn btn-outline-primary"
                data-code=""
                data-unitname="Unit 1"
              >
                <i className="mdi mdi-code-tags"></i>
                <span>Generate Code</span>
              </a>
            </td>
          </tr>
        ));
      return tableData;
  }
};

export const equalTo = (a, b) => a + '' === b + '';

export const notEqualTo = (a, b) => a + '' !== b + '';

export const getIndividualData = data => {
  let arr = [];
  data.forEach(item => {
    _.omit(item, ['errors']);
    for (let i = 0; i < item.tenantsList.length; i++) {
      let obj = {};
      obj.roleId = item.roleId;
      obj.isActive = parseInt(item.isActive) ? parseInt(item.isActive) : 1;
      obj.isRecActive = parseInt(item.isRecActive);
      obj.tenantId = item.tenantsList[i];
      arr.push(obj);
    }
  })
  return arr;
}



export const getCombinedData = (data) => {
  let obj = [];
  let x = _.groupBy(data, 'roleId');
  let y = _.flatten(Object.keys(x).map(i => _.groupBy(x[i], 'isRecActive')));

  y.forEach(i => {
    let ids = [], names = [], temp = {};

    Object.keys(i).forEach((j, p) => {
      temp = i[j][0];
      temp = _.omit(temp, ['tenantId'])
      i[j].forEach(item => {
        ids.push(item.tenantId);
        names.push(item.tenantName);
      })
      obj.push({ ...temp, tenantsList: ids, tenantName: names });

      temp = {}; ids = []; names = [];
    })
  });
  return obj;
}

export const getUserListData = (data) => {
  let rtnData = []

  data.forEach(item => {
    item.roleTenantList.forEach(childItem => {
      rtnData.push({
        contact: item.contact,
        email: item.email,
        id: item.id,
        name: item.name,
        isRecActive: item.isRecActive,
        isActive: item.isActive,
        roleList: childItem.roleName,
        tenantList: childItem.tenantName,
        modifiedOn: item.modifiedOn,
        isUserPrimary: item.isUserPrimary
      })
    });
  });

  return rtnData
}


export const getTenantCountry = (id) => {
  let country = '';
  let signInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (signInData && signInData.responseList && signInData.responseList.length > 0) {
    let findAdvData = signInData.responseList.find((data) => data.tenantId == id);
    if (findAdvData && findAdvData.contact && findAdvData.contact.country && findAdvData.contact.country.length > 0) {
      country = findAdvData.contact.country.toLowerCase();
    }
  }
  return country;
}

export const getTenantCurrency = (id) => {
  let currency = '';
  let signInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (signInData && signInData.responseList && signInData.responseList.length > 0) {
    let findAdvData = signInData.responseList.find((data) => data.tenantId == id);
    if (findAdvData && findAdvData.currencyType) {
      currency = findAdvData.currencyType;
    }
  }
  return currency;
}

export async function getPlatformConfig() {
  try {
    const response = await axios.get(platformConfigUrl);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function isValidUrl(url) {
  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(url);
}

export function validatePlatform(platform) {
  // Check if 'lable' key exists
  if (!platform.hasOwnProperty('lable')) {
    return false;
  }
  // Check if 'name' key exists within 'lable'
  if (!platform.hasOwnProperty('name')) {
    return false;
  }
  // Check if 'logo' object exists within 'lable' and 'path' is a valid URL
  if (!platform.lable.hasOwnProperty('logo') && Array.isArray(platform['lable']['logo']) && !isValidUrl(platform['lable']['logo'][0]['path'])) {
    return false;
  }
  // Check if 'favicon' is a valid URL
  if (!isValidUrl(platform.lable.favicon)) {
    return false;
  }

  // If all checks pass, return true
  return true;
}

export const isTenantAdvertiser = (tenantId = -1) => {
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.tenantType && dataFind.tenantType.toLowerCase() == "advertiser")
    // if (preSignInData.responseList.find((data) => data.tenantId == tenantId).tenantType.toLowerCase() == "Advertiser & DSP/Ad network")
    {
      return true;
    }
    else {
      return false;
    }
  }
}

export const isTenantPlatformManager = (tenantId = -1) => {
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.tenantType && dataFind.tenantType.toLowerCase() == "platform manager") {
      return true;
    }
    else {
      return false;
    }
  }
}

/**
 * Checks if the specified tenant is a demo advertiser.
 *
 * This function retrieves pre-sign-in data from local storage and checks
 * if the tenant with the given tenantId is classified as a "demo advertiser".
 * If not, it delegates the check to `isTenantDemoAgency` to see if the tenant
 * is a "demo agency".
 *
 * @param {number} tenantId - The ID of the tenant to check. Default is -1.
 * @returns {boolean} - Returns true if the tenant is a demo advertiser,
 *                      otherwise delegates to `isTenantDemoAgency`.
 */

export const isTenantDemoAdvertiser = (tenantId = -1) => {
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.tenantType && dataFind.tenantType.toLowerCase() == "demo advertiser") {
      return true;
    }
    else {
      return isTenantDemoAgency(tenantId);
    }
  }
}

export const isTenantDemoAgency = (tenantId = -1) => {
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.tenantType && dataFind.tenantType.toLowerCase() == "demo agency") {
      return true;
    }
    else {
      return false;
    }
  }
}

export const isTenantAgency = (tenantId = -1) => {
  try {
    let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
    if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
      let value = preSignInData.responseList.find((data) => data.tenantId == tenantId);
      let isAgency = false;
      if (value) {
        isAgency = value.tenantType == "DSP/Ad network" || value.tenantType == "Advertiser & DSP/Ad network" || value.tenantType == "Demo Agency" ? true : false;
      }
      return isAgency;
    }
  } catch (error) {
    console.error("Error in isTenantAgency:", error);
    return false;
  }
}

export const isApiCallSuccess = (status = '') => {
  return status.toLowerCase() == "success";
}

export const formatDate = (date, formatedText) => {
  if (date === null || date === undefined || date === '' || date.toLowerCase() === 'invalid date') {
    return '-';
  }
  return moment(date).format(formatedText)
}

export const getValidCampaignsId = (campaigns = []) => {
  return campaigns
    .filter((dataCampaign) => {
      return (
        dataCampaign.strategies &&
        dataCampaign.strategies.length > 0 &&
        dataCampaign.strategies.every(
          (item) =>
            "creative" in item &&
            "creatives" in item.creative &&
            item.creative.creatives.length > 0
        )
      );
    })
    .map((dataCampaign) => dataCampaign.id);
};

export const removeEmptyObjAndStringFromObject = (obj) => {
  for (let key in obj) {
    if (typeof (obj[key]) == "string" && obj[key] === '') {
      delete obj[key];
    }
    if (!Array.isArray(obj[key]) && typeof (obj[key]) == "object" && Object.keys(obj[key]).length == 0) {
      delete obj[key];
    }
  }
  return obj;
}

export const getDashValueIfKeyNotExists = (obj, key) => {
  if (obj[key]) {
    return obj[key]
  }
  else {
    return '-'
  }
}


function stringToHex(str) {
  let hex = "";
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i).toString(16);
    hex += charCode.padStart(2, "0");
  }
  return hex;
}

export const isPlatformManager = () => {
  try {
    let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
    if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0) {
      return preSignInData.responseList[0].tenantType == "Platform Manager";
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
  }
}

export const isDateSame = (date1, date2) => {
  // Check if both dates are defined and compare them using moment's isSame method
  return (date1 && date2) ? moment(date1).isSame(moment(date2), 'day') : false;
};

export const generateRandomIdData = () => {
  // Generate a random number between 1 and 100000
  let randomNum = Math.floor(Math.random() * 100000) + 1;

  // Get the current date-time
  let dateTime = new Date().getTime();

  // Concatenate the random number and date-time
  let combinedString = randomNum + dateTime;

  return combinedString;
}

export const capitalizeFirstLetter = (str = '') => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const updateConfigListDataWithDisplayName = (list) => {
  return list.map((data) => ({
    ...data,
    name:
      data.displayName && data.displayName.length > 0
        ? data.displayName
        : data.name,
  }));
}

export const getMessagesData = (list = []) => {
  let message = '';
  if (list.length > 0 && list[0].description && list[0].description.length > 0) {
    message = list[0].description;
  }
  return message;
}


export const getUserSelectedDateInUtc = ({ date, targetTimeZone, isStartDate }) => {
  const timeString = momentTimeZone.tz(targetTimeZone).format('HH:mm:ss');
  let startDate = `${moment(date).format('YYYY-MM-DD')} ${timeString}`;
  const localDate = momentTimeZone.tz(startDate, 'YYYY-MM-DD HH:mm:ss', targetTimeZone);

  // Convert the parsed date to UTC
  const utcDate = localDate.clone().utc();

  // Format the UTC date and time as desired
  const utcDateString = utcDate.format('YYYY-MM-DD HH:mm:ss');
  return utcDateString;
}

export const getUserSelectedDateInUtcForEndDate = ({ date, targetTimeZone, isStartDate }) => {
  const timeString = isStartDate ? '00:00:00' : '23:59:59';
  let startDate = `${moment(date).format('YYYY-MM-DD')} ${timeString}`;
  const localDate = momentTimeZone.tz(startDate, 'YYYY-MM-DD HH:mm:ss', targetTimeZone);

  // Convert the parsed date to UTC
  const utcDate = localDate.clone().utc();

  // Format the UTC date and time as desired
  const utcDateString = utcDate.format('YYYY-MM-DD HH:mm:ss');
  return utcDateString;
}

export const getTenantTimeZone = (tenantId = "") => {
  const targetDefaultTimeZone = "Asia/calcutta";
  // const targetTimeZone = "Pacific/Pago_Pago";
  // const targetTimeZone = "America/Sao_Paulo";
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.timezoneValue) {
      return dataFind.timezoneValue;
    }
  }
  return targetDefaultTimeZone;
}

export const getTenantTimeZoneId = (tenantId = "") => {
  const targetDefaultTimeZoneId = -1;
  let preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  if (preSignInData && preSignInData.responseList && preSignInData.responseList.length > 0 && tenantId >= 0) {
    let dataFind = preSignInData.responseList.find((data) => data.tenantId == tenantId);
    if (dataFind && dataFind.timezoneValue) {
      return dataFind.timezone;
    }
  }
  return targetDefaultTimeZoneId;
}

export const getCurrentDateInTimeZone = (targetTimeZone = "") => {
  const userCurrentDateTime = momentTimeZone.tz(targetTimeZone);
  const dateFormat = userCurrentDateTime.format('YYYY-MM-DD');
  // const dateAtMidnight = momentTimeZone.tz(`${dateFormat} 00:00:00`, 'YYYY-MM-DD HH:mm:ss', targetTimeZone);
  return `${dateFormat} 00:00:00`;
}

export const getDateInUtcFormat = ({ date = "", targetTimeZone = "", isStartDate = "" }) => {
  const timeString = momentTimeZone.tz(targetTimeZone).format('HH:mm:ss');
  const userCurrentDate = momentTimeZone.tz(date, targetTimeZone).format('YYYY-MM-DD');
  const dateAtMidnight = momentTimeZone.tz(`${userCurrentDate} ${timeString}`, 'YYYY-MM-DD HH:mm:ss', targetTimeZone);
  const dateFormatUTC = dateAtMidnight.clone().utc().format('YYYY-MM-DD HH:mm:ss');
  return dateFormatUTC;
}

export const getDateFromUtcToSpecificZone = ({ date = "", targetTimeZone = "" }) => {
  const utcDate = momentTimeZone.utc(date, 'YYYY-MM-DD HH:mm:ss');
  const targetDateTime = utcDate.tz(targetTimeZone);
  return targetDateTime.format('YYYY-MM-DD HH:mm:ss');
}

const appendTimestampData = async (data) => {
  const timestampEndpoint = `${timestampBaseUrl}/get/time`;
  try {
    const headers = new Headers();
    headers.append('Origin', apiBaseUrl);
    const response = await fetch(timestampEndpoint, {
      referrerPolicy: 'origin',
      method: 'GET',
      headers,
      mode: 'cors'
    });
    const timestampData = await response.json();
    return { ...data, timeStamp: timestampData.timestamp };
  } catch (error) {
    console.error(error.message);
    return { ...data, timeStamp: new Date().getTime() };
  }
};

export const generateUniqueAlphanumeric = (length = 12) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(
      Math.floor(Math.random() * characters.length)
    );
  }
  return result;
}

export const encryptAuthData = async (data) => {
  // let encryptedData = { ...data, timeStamp: new Date().getTime() };
  let encryptedData = await appendTimestampData(data);
  const md5Hash = CryptoJS.MD5(data.password).toString();
  encryptedData.password = md5Hash;
  const blowfish = new Blowfish(process.env.REACT_APP_BLOWFISH_SECRET_KEY);
  const ciphertext = blowfish.encrypt(JSON.stringify(encryptedData));
  const cipherHexEncode = stringToHex(ciphertext);
  return cipherHexEncode;
}

export const encryptDataWithBlowfish = async (data, type = 'obj') => {
  const blowfish = new Blowfish(process.env.REACT_APP_BLOWFISH_SECRET_KEY);
  if (type == 'obj') {
    // let encryptedData = { ...data, timeStamp: new Date().getTime() };
    let encryptedData = await appendTimestampData(data);
    const ciphertext = blowfish.encrypt(JSON.stringify(encryptedData));
    const cipherHexEncode = stringToHex(ciphertext);
    return cipherHexEncode;
  } else {
    const ciphertext = blowfish.encrypt(data);
    const cipherHexEncode = stringToHex(ciphertext);
    return cipherHexEncode;
  }
}

export const checkConnectionManagementAccess = () => {
  let CheckAccountType = JSON.parse(localStorage.getItem('PreSignInData'));
  let logedInTenantID = JSON.parse(localStorage.getItem('PreSignInState'));
  let findAccountType = {}
  if (CheckAccountType && CheckAccountType.responseList && CheckAccountType.responseList.length > 0 && logedInTenantID) {
    findAccountType = CheckAccountType.responseList.find((data) => data.tenantId == logedInTenantID.tenantId);
  }
  const { tenantType, miscData } = findAccountType;
  // Return early if tenantType is 'Platform Manager'
  if (tenantType.toLowerCase() == 'platform manager') return true;
  // If miscData is not provided or is empty, return false
  if (!miscData || miscData.length === 0) return false;
  // Find the connectionManagement object
  const connectionManagement = miscData.find(obj => obj.key === 'connectionManagement');
  // Return true if connectionManagement exists and its value is  1
  return connectionManagement && Number(connectionManagement.value) === 1;
};

export const checkFeeManagementAccess = () => {
  let CheckAccountType = JSON.parse(localStorage.getItem('PreSignInData'));
  let logedInTenantID = JSON.parse(localStorage.getItem('PreSignInState'));
  let findAccountType = {}
  if (CheckAccountType && CheckAccountType.responseList && CheckAccountType.responseList.length > 0 && logedInTenantID) {
    findAccountType = CheckAccountType.responseList.find((data) => data.tenantId == logedInTenantID.tenantId);
  }
  const { tenantType, miscData } = findAccountType;
  // Return early if tenantType is 'Platform Manager'
  if (tenantType.toLowerCase() == 'platform manager') return true;
  // If miscData is not provided or is empty, return false
  if (!miscData || miscData.length === 0) return false;
  // Find the connectionManagement object
  const feeManagement = miscData.find(obj => obj.key == 'feeManagement');
  // Return true if connectionManagement exists and its value is  1
  return feeManagement && Number(feeManagement.value) === 1;
};

export const checkSubscriptionAllowed = () => {
  let CheckAccountType = JSON.parse(localStorage.getItem('PreSignInData'));
  let logedInTenantID = JSON.parse(localStorage.getItem('PreSignInState'));
  let findAccountType = {}
  if (CheckAccountType && CheckAccountType.responseList && CheckAccountType.responseList.length > 0 && logedInTenantID) {
    findAccountType = CheckAccountType.responseList.find((data) => data.tenantId == logedInTenantID.tenantId);
  }
  const { tenantType, miscData, tenantMode } = findAccountType;

  // Return early if tenantType is 'Platform Manager'

  if (tenantType.toLowerCase() == 'platform manager') return false;

  // If miscData is not provided or is empty, return false
  if (!miscData || miscData.length === 0) return false;

  // Find the connectionManagement object
  const subscriptionAllowed = miscData.find(obj => obj.key == 'subscriptionAllowed');

  // Return true if connectionManagement exists and its value is  1
  if (subscriptionAllowed === undefined) {
    return tenantMode == 0 ? false : true; // tenantMode[0:manage server; 1:self serve]
  } else {
    return Number(subscriptionAllowed.value) === 1; // Return true if subscriptionAllowed.value is 1
  }
};
export const scrollToElement = (elementId) => {
  try {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  } catch (e) {
    console.log(e);
  }
}

export const isDemoCampaign = (campaignList, targetCampaignId) => {
  return campaignList.some(({ campaignId }) => campaignId == targetCampaignId);
}

export const isPlatformBidBudgetEmpty = (marginDetails = []) => {
  const details = Array.isArray(marginDetails) ? marginDetails : [];
  return details.every((margin) => !margin || (!Object.prototype.hasOwnProperty.call(margin, "atdBid") && !Object.prototype.hasOwnProperty.call(margin, "atdBudget")))
}

export const hasMarginMessageHandler = (marginDetails = []) => {
  const details = Array.isArray(marginDetails) ? marginDetails : [];
  return details.some((margin) => margin && Object.prototype.hasOwnProperty.call(margin, "marginMessage"))
}

export const isAlphanumeric = (input) => {
  const pattern = /^[a-zA-Z0-9]*$/;
  return pattern.test(input);
}

// return platform based on platformName
export const whichPlatform = ({ platformData = [], platformName = "" }) => {
  if (!platformName) return;
  if (!platformData.length) return;
  const platformFound = platformData.find(plat => plat.value.toLowerCase() == platformName.toLowerCase());
  return platformFound;
}

export function trimDisplayName(str, size = 10) {
  if (!str) return str;
  const n = str.length;

  if (n <= size * 3) return str;

  const start = str.slice(0, size);
  const midStart = Math.floor(n / 2) - Math.floor(size / 2);
  const mid = str.slice(midStart, midStart + size);
  const end = str.slice(-size);

  return `${start}...${mid}...${end}`;
}

export function getCsvHeaders(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const firstLine = text.split('\n')[0];
        const headers = firstLine.split(',').map((h) => h.trim());

        resolve(headers);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsText(file);
  });
};

export const findPlatformById = ({ platformData = [], platformId }) => {
  if (!platformId) return;
  if (!platformData.length) return;
  const platformFound = platformData.find(plat => plat.key == platformId);
  return platformFound;
}


export const isMvpPlatform = (platformName = '') => {
  const name = platformName.trim().toLowerCase();
  if (!name) return false;

  const mvpPlatformList = ['snapchat', 'flipkart', 'amazon', 'whatsapp'];
  return mvpPlatformList.includes(name);
};

export const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const debouncedFunction = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);

  return debouncedFunction;
};
